import { jsx as e, jsxs as c, Fragment as be } from "react/jsx-runtime";
import * as j from "react";
import { useMemo as ee, Suspense as Rt, useState as L, useRef as De, useEffect as re, useCallback as ge, useId as $t, createContext as Ot, useContext as zt } from "react";
import { Breadcrumb as Wt, Card as _e, Layout as oe, theme as Y, Grid as Je, Spin as St, ConfigProvider as qt, Tooltip as vt, Typography as E, Space as V, Tag as pe, Button as U, Menu as Ge, Badge as Ht, Avatar as wt, DatePicker as xt, Empty as Vt, Drawer as jt, App as Se, Steps as et, Form as v, Select as Ue, InputNumber as tt, Modal as Ee, Input as z, Popconfirm as Gt, Alert as We, Tree as Yt, Table as K, Descriptions as le, Divider as Kt, Row as Ye, Col as qe, Progress as Qt, Radio as Ie, Checkbox as Me, Upload as Xt, Collapse as Zt } from "antd";
import { Link as He, Outlet as Jt, useNavigate as nt } from "react-router-dom";
import { BellIcon as en, ChevronDownIcon as tn } from "@heroicons/react/24/outline";
import { MenuUnfoldOutlined as nn, MenuFoldOutlined as rn, DeleteOutlined as kt, SearchOutlined as on, DownloadOutlined as an, PrinterOutlined as ln, InboxOutlined as sn, SunOutlined as cn, MoonOutlined as dn, FacebookFilled as un, CheckCircleFilled as mn } from "@ant-design/icons";
import ae from "dayjs";
import hn from "dayjs/plugin/isoWeek.js";
import { ResponsiveContainer as pn, BarChart as gn, XAxis as fn, YAxis as yn, Tooltip as bn, ReferenceLine as st, Bar as Sn } from "recharts";
import { getMessage as d } from "@digiwedge/i18n-messages";
import { z as vn } from "zod";
import { useMutation as wn, QueryClient as xn, QueryClientProvider as kn } from "@tanstack/react-query";
import { TenantsApi as Cn } from "@digiwedge/access-control-api-client";
import { useTheme as Ct, useLocale as Tn } from "@digiwedge/ui-theme";
import { AppThemeProvider as Ki } from "@digiwedge/ui-theme";
import { useLogin as Tt, useVerifyLoginMfa as _n, classifyAxiosError as Nn, useRegister as _t, useLogout as An, useRegisterSmsMfa as Ln, useVerifySmsMfa as Dn } from "@digiwedge/hooks-auth-web";
import { isAxiosError as In } from "axios";
import { parseLocationForOAuthError as Mn } from "@digiwedge/oauth-redirect-utils";
const oi = ({
  breadcrumbItems: t = [],
  separator: n = ">",
  style: r = { margin: "16px 0" },
  renderItem: o
}) => {
  const i = ee(() => t.map((l, u) => {
    const a = u === t.length - 1;
    let s;
    return o ? s = o(l, a) : a ? s = /* @__PURE__ */ e("span", { style: { fontWeight: "bold" }, children: l.name }) : s = l.path ? /* @__PURE__ */ e(He, { to: l.path, children: l.name }) : l.name, { title: s };
  }), [t, o]);
  return /* @__PURE__ */ e(Wt, { items: i, separator: n, style: r });
}, ii = ({ img: t, icon: n, title: r }) => /* @__PURE__ */ c(
  _e,
  {
    hoverable: !0,
    style: { width: "100%", borderRadius: 12 },
    bodyStyle: {
      padding: 12,
      display: "flex",
      alignItems: "center",
      gap: 4,
      whiteSpace: "nowrap"
    },
    cover: /* @__PURE__ */ e(
      "div",
      {
        style: {
          height: 120,
          backgroundImage: `url(${t})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }
      }
    ),
    children: [
      n,
      /* @__PURE__ */ e(
        "div",
        {
          style: {
            fontWeight: 600,
            fontSize: 14,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: r
        }
      )
    ]
  }
), { Content: Un } = oe, ai = ({
  children: t,
  padding: n,
  responsivePadding: r
}) => {
  const {
    token: { colorBgContainer: o }
  } = Y.useToken(), i = Je.useBreakpoint(), l = j.useMemo(() => {
    if (r) {
      const u = ["xxl", "xl", "lg", "md", "sm", "xs"];
      for (const a of u)
        if (i[a] && typeof r[a] == "number")
          return r[a];
    }
    return typeof n == "number" ? n : 24;
  }, [i, n, r]);
  return /* @__PURE__ */ e(
    Un,
    {
      style: {
        padding: l,
        minHeight: "calc(100vh - 64px - 70px)",
        // Adjust for header and footer
        background: o
        // Dynamic background color based on theme
      },
      children: /* @__PURE__ */ e(
        Rt,
        {
          fallback: /* @__PURE__ */ e(
            St,
            {
              size: "large",
              style: {
                display: "block",
                margin: "auto",
                marginTop: "20%"
                // Center the spinner vertically
              }
            }
          ),
          children: t || /* @__PURE__ */ e(Jt, {})
        }
      )
    }
  );
}, xe = 48, Nt = "env(safe-area-inset-bottom)", li = (t) => `calc(${t}px + ${Nt})`, { Footer: En } = oe, Fn = {
  facebook: /* @__PURE__ */ e("i", { className: "fab fa-facebook" }),
  twitter: /* @__PURE__ */ e("i", { className: "fab fa-twitter" }),
  instagram: /* @__PURE__ */ e("i", { className: "fab fa-instagram" }),
  linkedin: /* @__PURE__ */ e("i", { className: "fab fa-linkedin" })
  // Add more icons as needed
}, Pn = ({
  text: t = "© 2025 DigiWedge. All rights reserved.",
  style: n,
  socialMedia: r = [],
  bgColor: o,
  borderColor: i,
  highlightColor: l,
  themeMode: u,
  brandName: a = "Tee Time",
  brandDescription: s = "Book tee times, discover golf clubs, and enjoy exclusive deals. Your perfect round starts here.",
  quickLinks: m = [
    { label: "Find Clubs", href: "/clubs" },
    { label: "Featured Deals", href: "/specials" },
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "FAQ", href: "/faq" }
  ],
  contactEmail: h = "support@teetime.com",
  contactPhone: f = "+1 234 567 890",
  showNewsletter: N = !0,
  newsletterTitle: C = "Subscribe to our Newsletter",
  newsletterPlaceholder: y = "Your email",
  newsletterButtonLabel: S = "Subscribe"
}) => {
  const { token: b } = Y.useToken(), D = u ?? "light", g = u != null ? Y.getDesignToken({
    algorithm: D === "dark" ? Y.darkAlgorithm : Y.defaultAlgorithm
  }) : b, A = o ?? g.colorBgContainer, W = i ?? g.colorSplit ?? g.colorBorderSecondary, q = g.colorText, w = g.colorTextDescription ?? g.colorTextSecondary ?? q, F = l ?? g.colorPrimary, H = g.colorBgLayout, p = `clamp(${g.paddingSM}px, 6vw, ${g.paddingXL}px)`, I = m ?? [], T = I.length > 0, x = !!(h || f), M = {
    textAlign: "center",
    padding: 0,
    marginTop: g.marginXL,
    backgroundColor: A,
    color: q,
    borderTop: `1px solid ${W}`,
    ...n
  }, B = /* @__PURE__ */ c(En, { style: { ...M }, children: [
    /* @__PURE__ */ c(
      "div",
      {
        style: {
          width: "100%",
          padding: `24px ${p}`,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: g.marginLG,
          minHeight: xe
        },
        children: [
          /* @__PURE__ */ c("div", { style: { marginBottom: g.marginMD, textAlign: "left", maxWidth: 320 }, children: [
            /* @__PURE__ */ e(
              "div",
              {
                style: {
                  fontWeight: 700,
                  fontSize: 22,
                  color: F,
                  marginBottom: g.marginSM
                },
                children: a
              }
            ),
            /* @__PURE__ */ e("div", { style: { color: w, fontSize: 14 }, children: s })
          ] }),
          T && /* @__PURE__ */ c("div", { style: { marginBottom: g.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: g.marginSM }, children: "Quick Links" }),
            /* @__PURE__ */ e("div", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: I.map((P) => /* @__PURE__ */ e("a", { href: P.href, style: { color: q }, children: P.label }, P.href)) })
          ] }),
          x && /* @__PURE__ */ c("div", { style: { marginBottom: g.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: g.marginSM }, children: "Contact" }),
            /* @__PURE__ */ c("div", { style: { fontSize: 14 }, children: [
              h && /* @__PURE__ */ c(be, { children: [
                "Email:",
                " ",
                /* @__PURE__ */ e("a", { href: `mailto:${h}`, style: { color: F }, children: h })
              ] }),
              h && f && /* @__PURE__ */ e("br", {}),
              f && /* @__PURE__ */ c(be, { children: [
                "Phone:",
                " ",
                /* @__PURE__ */ e("a", { href: `tel:${f.replace(/\s/g, "")}`, style: { color: q }, children: f })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { style: { marginTop: g.marginSM }, children: r.length > 0 ? r.map(
              (P) => P.href ? /* @__PURE__ */ e(
                "a",
                {
                  href: P.href,
                  "aria-label": P.platform,
                  style: { margin: "0 8px", color: F },
                  children: P.icon || Fn[P.platform.toLowerCase()]
                },
                P.href
              ) : null
            ) : /* @__PURE__ */ c(be, { children: [
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://facebook.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Facebook",
                  style: { margin: "0 8px", color: F },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-facebook" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://twitter.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Twitter",
                  style: { margin: "0 8px", color: F },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-twitter" })
                }
              ),
              /* @__PURE__ */ e(
                "a",
                {
                  href: "https://instagram.com",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "aria-label": "Instagram",
                  style: { margin: "0 8px", color: F },
                  children: /* @__PURE__ */ e("i", { className: "fab fa-instagram" })
                }
              )
            ] }) })
          ] }),
          N && /* @__PURE__ */ c("div", { style: { marginBottom: g.marginMD, textAlign: "left" }, children: [
            /* @__PURE__ */ e("div", { style: { fontWeight: 600, marginBottom: g.marginSM }, children: C }),
            /* @__PURE__ */ c(
              "form",
              {
                onSubmit: (P) => P.preventDefault(),
                style: { display: "flex", gap: g.marginSM, flexWrap: "wrap" },
                children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      type: "email",
                      placeholder: y,
                      "aria-label": y,
                      style: {
                        flex: 1,
                        padding: 6,
                        borderRadius: g.borderRadius,
                        border: `1px solid ${g.colorBorder}`,
                        background: g.colorBgContainer,
                        color: q
                      }
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      type: "submit",
                      style: {
                        background: F,
                        color: g.colorTextLightSolid,
                        border: "none",
                        borderRadius: g.borderRadius,
                        padding: "6px 14px",
                        fontWeight: 600,
                        cursor: "pointer"
                      },
                      children: S
                    }
                  )
                ]
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        style: {
          color: w,
          fontSize: 13,
          padding: "16px 0",
          width: "100%",
          backgroundColor: H
        },
        children: /* @__PURE__ */ c(
          "div",
          {
            style: {
              width: "100%",
              padding: `0 ${p}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              rowGap: g.marginSM,
              whiteSpace: "nowrap"
            },
            children: [
              /* @__PURE__ */ e("p", { style: { margin: 0 }, children: t }),
              /* @__PURE__ */ e("div", { style: { width: "100%" } }),
              /* @__PURE__ */ c("div", { style: { display: "flex", gap: 16, whiteSpace: "nowrap" }, children: [
                /* @__PURE__ */ e("a", { href: "/terms", style: { color: w }, children: "Terms of Service" }),
                /* @__PURE__ */ e("a", { href: "/privacy", style: { color: w }, children: "Privacy Policy" })
              ] })
            ]
          }
        )
      }
    )
  ] });
  return u ? /* @__PURE__ */ e(
    qt,
    {
      theme: { algorithm: D === "dark" ? Y.darkAlgorithm : Y.defaultAlgorithm },
      children: B
    }
  ) : B;
}, si = Pn, { Footer: Bn } = oe, ct = {
  dev: { color: "geekblue", label: "DEV" },
  uat: { color: "gold", label: "UAT" },
  prod: { color: "success", label: "PROD" }
}, Rn = 7, ci = ({
  orgName: t,
  env: n,
  version: r,
  commit: o,
  syncInfo: i,
  links: l,
  bordered: u = !0
}) => {
  const { token: a } = Y.useToken(), s = a.colorBgContainer, m = a.colorSplit ?? a.colorBorderSecondary, h = a.colorTextDescription ?? a.colorTextSecondary, f = `clamp(${a.paddingSM}px, 5vw, ${a.paddingLG}px)`, N = i ? i.tooltip ? /* @__PURE__ */ e(vt, { title: i.tooltip, placement: "top", children: /* @__PURE__ */ e(E.Text, { style: { color: h }, children: i.label }) }) : /* @__PURE__ */ e(E.Text, { style: { color: h }, children: i.label }) : null, C = r ? /* @__PURE__ */ c(E.Text, { style: { color: h }, children: [
    "v",
    r
  ] }) : null, y = o ? /* @__PURE__ */ e(E.Text, { code: !0, style: { color: h }, children: o.slice(0, Rn) }) : null, S = l?.length ? /* @__PURE__ */ e(V, { size: a.marginSM, wrap: !0, children: l.map((b) => /* @__PURE__ */ e(E.Link, { href: b.href, style: { color: a.colorPrimary }, children: b.label }, b.href)) }) : null;
  return /* @__PURE__ */ e(
    Bn,
    {
      style: {
        background: s,
        borderTop: u ? `1px solid ${m}` : void 0,
        padding: `${a.paddingSM}px ${f}`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: a.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: a.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e(E.Text, { strong: !0, children: t ?? "DigiWedge Admin" }),
              N
            ] }),
            /* @__PURE__ */ c(V, { size: a.marginSM, wrap: !0, children: [
              n ? /* @__PURE__ */ e(pe, { color: ct[n].color, children: ct[n].label }) : null,
              C,
              y,
              S
            ] })
          ]
        }
      )
    }
  );
}, { Footer: $n } = oe, di = ({
  primary: t,
  secondary: n,
  status: r,
  sticky: o = !0,
  safeArea: i = !0
}) => {
  const { token: l } = Y.useToken(), u = l.colorBgContainer, a = l.colorSplit ?? l.colorBorderSecondary, s = i ? `calc(${l.paddingSM}px + ${Nt})` : `${l.paddingSM}px`;
  return /* @__PURE__ */ e(
    $n,
    {
      style: {
        background: u,
        borderTop: `1px solid ${a}`,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 6vw, ${l.paddingLG}px) ${s}`,
        position: o ? "sticky" : "static",
        bottom: o ? 0 : void 0,
        zIndex: o ? l.zIndexPopupBase : void 0
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: l.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ e("div", { style: { minHeight: 24, flex: 1 }, children: r ? typeof r == "string" ? /* @__PURE__ */ e(E.Text, { type: "secondary", children: r }) : r : null }),
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              n?.map((m) => /* @__PURE__ */ e(U, { onClick: m.onClick, children: m.label }, m.label)),
              /* @__PURE__ */ e(
                U,
                {
                  type: "primary",
                  onClick: t.onClick,
                  disabled: t.disabled,
                  loading: t.loading,
                  children: t.label
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, { Footer: On } = oe, ui = ({
  selectedCount: t = 0,
  bulkActions: n,
  pagination: r,
  extra: o,
  bordered: i = !0
}) => {
  const { token: l } = Y.useToken(), u = l.colorSplit ?? l.colorBorderSecondary, a = l.colorBgContainer, s = t > 0, [m, h] = L(!1), [f, N] = L(-1), C = De(null), y = De(null), S = De([]);
  re(() => {
    !s && m && h(!1);
  }, [s, m]);
  const b = ee(() => n?.length ? n.filter(
    (w) => !!(w?.key && w?.label && typeof w.onClick == "function")
  ) : [], [n]), D = b.length > 0, g = s && D, A = ge(() => {
    g && h((w) => !w);
  }, [g]);
  re(() => {
    if (!m) {
      N(-1);
      return;
    }
    b.length > 0 && (N(0), S.current[0]?.focus());
    const w = (H) => {
      const p = H.target;
      p && (y.current?.contains(p) || C.current?.contains(p) || h(!1));
    }, F = (H) => {
      H.key === "Escape" && (h(!1), C.current?.focus());
    };
    return document.addEventListener("mousedown", w), document.addEventListener("keydown", F), () => {
      document.removeEventListener("mousedown", w), document.removeEventListener("keydown", F);
    };
  }, [m, b.length]);
  const W = ge((w) => {
    h(!1), w.onClick();
  }, []), q = ge(
    (w, F) => {
      const H = b.length;
      let p = F;
      switch (w.key) {
        case "ArrowDown":
          w.preventDefault(), p = (F + 1) % H;
          break;
        case "ArrowUp":
          w.preventDefault(), p = (F - 1 + H) % H;
          break;
        case "Home":
          w.preventDefault(), p = 0;
          break;
        case "End":
          w.preventDefault(), p = H - 1;
          break;
        case "Tab":
          h(!1);
          return;
        default:
          return;
      }
      N(p), S.current[p]?.focus();
    },
    [b.length]
  );
  return /* @__PURE__ */ e(
    On,
    {
      style: {
        background: a,
        borderTop: i ? `1px solid ${u}` : void 0,
        padding: `${l.paddingSM}px clamp(${l.paddingSM}px, 5vw, ${l.paddingLG}px)`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: l.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              s ? /* @__PURE__ */ c(E.Text, { strong: !0, children: [
                t,
                " selected"
              ] }) : /* @__PURE__ */ e(E.Text, { type: "secondary", children: "No rows selected" }),
              D ? /* @__PURE__ */ c("div", { style: { position: "relative" }, children: [
                /* @__PURE__ */ e(
                  U,
                  {
                    ref: C,
                    disabled: !g,
                    onClick: A,
                    "aria-haspopup": "menu",
                    "aria-expanded": g ? m : void 0,
                    children: "Bulk actions"
                  }
                ),
                m ? /* @__PURE__ */ e(
                  "div",
                  {
                    ref: y,
                    role: "menu",
                    "aria-label": "Bulk actions",
                    style: {
                      position: "absolute",
                      top: l.paddingLG,
                      left: 0,
                      background: a,
                      border: `1px solid ${u}`,
                      borderRadius: l.borderRadiusLG,
                      boxShadow: l.boxShadowSecondary,
                      minWidth: 160,
                      zIndex: l.zIndexPopupBase,
                      display: "flex",
                      flexDirection: "column"
                    },
                    children: b.map((w, F) => /* @__PURE__ */ e(
                      "button",
                      {
                        ref: (H) => {
                          S.current[F] = H;
                        },
                        type: "button",
                        role: "menuitem",
                        tabIndex: f === F ? 0 : -1,
                        onClick: () => W(w),
                        onKeyDown: (H) => q(H, F),
                        style: {
                          width: "100%",
                          padding: `${l.paddingXS}px ${l.paddingSM}px`,
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                          cursor: "pointer"
                        },
                        children: w.label
                      },
                      w.key
                    ))
                  }
                ) : null
              ] }) : null
            ] }),
            /* @__PURE__ */ c(V, { size: l.marginSM, wrap: !0, children: [
              o,
              r
            ] })
          ]
        }
      )
    }
  );
}, { Footer: zn } = oe, dt = (t) => t?.name ?? "—", mi = ({
  org: t,
  site: n,
  region: r,
  locale: o,
  impersonating: i,
  links: l
}) => {
  const { token: u } = Y.useToken();
  return /* @__PURE__ */ e(
    zn,
    {
      style: {
        background: u.colorBgContainer,
        borderTop: `1px solid ${u.colorSplit ?? u.colorBorderSecondary}`,
        padding: `${u.paddingSM}px clamp(${u.paddingSM}px, 5vw, ${u.paddingXL}px)`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: u.marginSM,
            minHeight: xe
          },
          children: [
            /* @__PURE__ */ c(V, { size: u.marginSM, wrap: !0, children: [
              /* @__PURE__ */ e(E.Text, { strong: !0, children: "Org:" }),
              /* @__PURE__ */ e(E.Text, { children: dt(t) }),
              /* @__PURE__ */ e(E.Text, { strong: !0, children: "Site:" }),
              /* @__PURE__ */ e(E.Text, { children: dt(n) }),
              r ? /* @__PURE__ */ e(pe, { color: "blue", bordered: !1, children: r.toUpperCase() }) : null,
              o ? /* @__PURE__ */ e(pe, { color: "purple", bordered: !1, children: o }) : null
            ] }),
            /* @__PURE__ */ c(V, { size: u.marginSM, wrap: !0, align: "center", children: [
              i ? /* @__PURE__ */ c(pe, { color: "orange", bordered: !1, children: [
                "Impersonating ",
                i.name
              ] }) : null,
              l?.map((a) => /* @__PURE__ */ c(E.Link, { href: a.href, style: { color: u.colorPrimary }, children: [
                a.icon,
                a.icon ? /* @__PURE__ */ e("span", { style: { marginLeft: 4 }, children: a.label }) : a.label
              ] }, a.href))
            ] })
          ]
        }
      )
    }
  );
}, { Footer: Wn } = oe, qn = {
  ok: "success",
  warn: "warning",
  err: "error"
}, hi = ({ metrics: t, legal: n }) => {
  const { token: r } = Y.useToken();
  return /* @__PURE__ */ e(
    Wn,
    {
      style: {
        background: r.colorBgContainer,
        borderTop: `1px solid ${r.colorSplit ?? r.colorBorderSecondary}`,
        padding: `${r.paddingSM}px clamp(${r.paddingSM}px, 6vw, ${r.paddingXL}px)`
      },
      children: /* @__PURE__ */ c(
        V,
        {
          orientation: "vertical",
          size: r.marginSM,
          style: { width: "100%", minHeight: xe },
          children: [
            /* @__PURE__ */ e(V, { size: r.marginSM, wrap: !0, children: t.map((o, i) => /* @__PURE__ */ c(
              pe,
              {
                color: o.status ? qn[o.status] : void 0,
                bordered: !1,
                style: { paddingInline: r.paddingXS, fontWeight: 500 },
                children: [
                  o.label,
                  ": ",
                  o.value
                ]
              },
              `${o.label}-${i}`
            )) }),
            n ? /* @__PURE__ */ e(E.Text, { type: "secondary", style: { fontSize: 12 }, children: n }) : null
          ]
        }
      )
    }
  );
}, { Footer: Hn } = oe, pi = ({
  text: t = "© DigiWedge. All rights reserved.",
  links: n,
  align: r = "spread"
}) => {
  const { token: o } = Y.useToken(), i = r === "center" ? "center" : "space-between", l = `clamp(${o.paddingSM}px, 4vw, ${o.paddingLG}px)`, u = `${o.paddingXS}px`;
  return /* @__PURE__ */ e(
    Hn,
    {
      style: {
        background: o.colorBgContainer,
        borderTop: `1px solid ${o.colorSplit ?? o.colorBorderSecondary}`,
        padding: `${u} ${l}`
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: i,
            alignItems: "center",
            flexWrap: "wrap",
            gap: o.marginSM,
            minHeight: xe,
            color: o.colorTextDescription ?? o.colorTextSecondary,
            fontSize: 12
          },
          children: [
            /* @__PURE__ */ e(E.Text, { type: "secondary", children: t }),
            n?.length ? /* @__PURE__ */ e(V, { size: o.marginSM, wrap: !0, children: n.map((a) => /* @__PURE__ */ e(E.Link, { href: a.href, style: { color: o.colorPrimary }, children: a.label }, a.href)) }) : null
          ]
        }
      )
    }
  );
}, { Header: Vn } = oe, gi = ({
  navItems: t,
  userMenuItems: n,
  notificationsCount: r = 0,
  user: o,
  selectedNavKey: i,
  borderColor: l,
  buttonColor: u,
  rightExtra: a,
  themeMode: s
}) => {
  const m = nt(), { token: h } = Y.useToken(), f = process.env.NODE_ENV === "test", N = o?.avatarUrl ? "transparent" : "#4caf50", C = o?.name?.[0]?.toUpperCase() ?? "UNK", y = j.useMemo(() => t?.filter((x) => x?.key === "/") ?? [], [t]), S = j.useMemo(() => At(y), [y]), b = j.useMemo(() => {
    if (!n?.length)
      return { items: [], autoNavigateKeys: /* @__PURE__ */ new Set() };
    const x = [], M = /* @__PURE__ */ new Set();
    for (const B of n) {
      if (!B || typeof B != "object" || !("key" in B) || B.key == null || !("label" in B))
        continue;
      const P = B.label;
      if (P == null)
        continue;
      const te = String(B.key), X = { ...B, key: te, label: P };
      x.push(X), j.isValidElement(P) || M.add(te);
    }
    return { items: x, autoNavigateKeys: M };
  }, [n]), D = b.items, g = b.autoNavigateKeys, A = D.length > 0, W = j.useRef(null), q = j.useRef(null), [w, F] = j.useState(!1), H = j.useCallback(() => {
    const x = W.current;
    x && typeof x.focus == "function" && x.focus();
  }, []), p = j.useCallback(
    (x) => {
      F(!1), x?.restoreFocus && requestAnimationFrame(() => {
        H();
      });
    },
    [H]
  ), I = j.useCallback(() => {
    A && F((x) => !x);
  }, [A]), T = j.useCallback(
    (x) => {
      A && (x.key === "Enter" || x.key === " ") && (x.preventDefault(), I());
    },
    [A, I]
  );
  return j.useEffect(() => {
    if (!w)
      return;
    const x = (M) => {
      const B = M.target;
      B && (q.current?.contains(B) || W.current?.contains(B) || p());
    };
    return document.addEventListener("mousedown", x), () => {
      document.removeEventListener("mousedown", x);
    };
  }, [p, w]), j.useEffect(() => {
    if (!w)
      return;
    const x = (M) => {
      M.key === "Escape" && (M.preventDefault(), p({ restoreFocus: !0 }));
    };
    return document.addEventListener("keydown", x), () => {
      document.removeEventListener("keydown", x);
    };
  }, [p, w]), /* @__PURE__ */ e(
    Vn,
    {
      style: {
        display: "flex",
        alignItems: "center",
        padding: 0,
        transition: "background 0.3s ease",
        borderBottom: `1px solid ${l || h.colorSplit || "#e0e0e0"}`,
        backgroundColor: h.colorBgContainer
      },
      children: /* @__PURE__ */ c(
        "div",
        {
          style: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "0 16px"
          },
          children: [
            /* @__PURE__ */ e(
              Ge,
              {
                mode: "horizontal",
                items: y,
                selectedKeys: i ? [i] : [],
                onClick: ({ key: x }) => m(x),
                style: {
                  flex: 1,
                  minWidth: 0,
                  background: "transparent",
                  borderBottom: "none"
                }
              }
            ),
            f && S.length ? /* @__PURE__ */ e("ul", { style: jn, "aria-hidden": !0, children: S.map((x) => /* @__PURE__ */ e("li", { children: x.label }, x.key)) }) : null,
            /* @__PURE__ */ c(V, { size: "middle", style: { marginLeft: "auto", display: "flex", alignItems: "center" }, children: [
              a,
              o?.name ? /* @__PURE__ */ c(be, { children: [
                !a && /* @__PURE__ */ e(
                  Ht,
                  {
                    count: r,
                    "aria-label": `${r} notifications`,
                    style: { alignSelf: "center" },
                    children: /* @__PURE__ */ e(
                      U,
                      {
                        type: "text",
                        icon: /* @__PURE__ */ e(en, { style: { width: 18, height: 18 } }),
                        "aria-label": "Notifications",
                        style: {
                          color: h.colorText,
                          ...u ? { background: u, borderColor: u, color: "#fff" } : {}
                        }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ c("div", { style: { position: "relative" }, children: [
                  /* @__PURE__ */ c(
                    V,
                    {
                      ref: W,
                      onClick: I,
                      onKeyDown: T,
                      role: "button",
                      tabIndex: A ? 0 : -1,
                      "aria-label": "User menu trigger",
                      "aria-haspopup": "menu",
                      "aria-expanded": A ? w : void 0,
                      style: { cursor: A ? "pointer" : "default", alignItems: "center" },
                      children: [
                        /* @__PURE__ */ e(
                          wt,
                          {
                            style: {
                              backgroundColor: N,
                              border: `2px solid ${h.colorPrimary}`
                            },
                            "aria-label": "User menu",
                            children: C
                          }
                        ),
                        /* @__PURE__ */ e(tn, { style: { fontSize: 12, color: h.colorText } })
                      ]
                    }
                  ),
                  w ? /* @__PURE__ */ e(
                    "div",
                    {
                      ref: q,
                      role: "menu",
                      "aria-label": "User actions",
                      style: {
                        position: "absolute",
                        top: "calc(100% + 4px)",
                        right: 0,
                        background: h.colorBgElevated,
                        border: `1px solid ${h.colorBorder}`,
                        borderRadius: h.borderRadiusLG,
                        boxShadow: h.boxShadowSecondary,
                        minWidth: 180,
                        zIndex: h.zIndexPopupBase,
                        overflow: "hidden"
                      },
                      children: /* @__PURE__ */ e(
                        Ge,
                        {
                          items: D,
                          selectable: !1,
                          onClick: (x) => {
                            p();
                            const M = String(x.key);
                            g.has(M) && (x.domEvent.defaultPrevented || m(M));
                          },
                          style: {
                            borderInlineEnd: "none",
                            boxShadow: "none"
                          },
                          mode: "vertical"
                        }
                      )
                    }
                  ) : null
                ] })
              ] }) : /* @__PURE__ */ c(be, { children: [
                /* @__PURE__ */ e(
                  U,
                  {
                    type: "link",
                    onClick: () => m("/login"),
                    className: `header-login-button ${u ? "custom-color" : ""}`,
                    style: u ? { color: u } : { color: h.colorPrimary },
                    children: "Login"
                  }
                ),
                /* @__PURE__ */ e(
                  U,
                  {
                    type: "primary",
                    onClick: () => m("/signup"),
                    style: u ? { background: u, borderColor: u, color: "#fff" } : {
                      background: h.colorPrimary,
                      borderColor: h.colorPrimary,
                      color: "#fff"
                    },
                    children: "Sign Up"
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  );
}, jn = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function At(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...At(r.children));
  }
  return n;
}
const rt = j.memo(
  ({
    themeMode: t = "light",
    size: n = "medium",
    // Defaults align visually with theme: light => light bg, dark => dark bg
    lightLogoSrc: r = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23ffffff"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23000000">Light Logo</text></svg>',
    darkLogoSrc: o = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="48"><rect width="150" height="48" fill="%23000000"/><text x="75" y="30" font-size="14" text-anchor="middle" fill="%23ffffff">Dark Logo</text></svg>',
    style: i,
    alt: l
  }) => /* @__PURE__ */ e(
    "img",
    {
      src: t === "dark" ? o : r,
      alt: l ?? `${t === "dark" ? "Dark" : "Light"} Mode Logo`,
      style: {
        ...{
          small: { height: "24px", width: "auto" },
          medium: { height: "48px", width: "auto" },
          large: { height: "72px", width: "auto" }
        }[n],
        ...i
      }
    }
  )
), { useBreakpoint: Gn } = Je, { Sider: Yn } = oe, { Text: Kn } = E, fi = ({
  collapsed: t,
  onCollapse: n,
  themeMode: r = "light",
  sidebarItems: o,
  onClick: i,
  selectedKeys: l,
  defaultSelectedKeys: u,
  defaultOpenKeys: a = [],
  logo: s,
  style: m,
  className: h,
  breakpoint: f = "md"
}) => {
  const { token: N } = Y.useToken(), C = Gn(), y = j.useRef(void 0), S = process.env.NODE_ENV === "test";
  j.useEffect(() => {
    const A = C[f];
    y.current !== void 0 && y.current !== A && n?.(!A), y.current = A;
  }, [C, f, n]);
  const b = j.useCallback(() => {
    n?.(!t);
  }, [t, n]), D = j.useMemo(
    () => ({
      theme: r,
      mode: "inline",
      items: o,
      onClick: i,
      selectedKeys: l,
      defaultSelectedKeys: u,
      defaultOpenKeys: a,
      style: { flex: 1, overflow: "auto" }
    }),
    [r, o, i, l, u, a]
  ), g = j.useMemo(() => Lt(o), [o]);
  return /* @__PURE__ */ c(
    Yn,
    {
      collapsible: !0,
      collapsed: t,
      theme: r,
      trigger: null,
      width: 240,
      collapsedWidth: 80,
      style: {
        height: "100%",
        maxHeight: "calc(100vh - 64px)",
        position: "sticky",
        top: 64,
        alignSelf: "flex-start",
        // Use token to dynamically adjust the background per theme
        background: N.colorBgContainer,
        paddingBottom: N.paddingLG,
        ...m
      },
      className: h,
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            style: {
              padding: N.padding,
              borderBottom: `1px solid ${N.colorBorder}`
            },
            children: s || /* @__PURE__ */ e(Kn, { strong: !0, children: t ? "Logo" : "Application Name" })
          }
        ),
        /* @__PURE__ */ e(Ge, { ...D }),
        S && g.length ? /* @__PURE__ */ e("ul", { style: Qn, "aria-hidden": !0, children: g.map((A) => /* @__PURE__ */ e("li", { children: A.label }, A.key)) }) : null,
        /* @__PURE__ */ e(
          U,
          {
            type: "text",
            onClick: b,
            icon: t ? /* @__PURE__ */ e(nn, {}) : /* @__PURE__ */ e(rn, {}),
            style: {
              width: "100%",
              borderRadius: 0,
              borderTop: `1px solid ${N.colorBorder}`
            },
            "aria-label": t ? "Expand sidebar" : "Collapse sidebar"
          }
        )
      ]
    }
  );
}, Qn = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0
};
function Lt(t) {
  if (!t?.length)
    return [];
  const n = [];
  for (const r of t) {
    if (!r || typeof r != "object")
      continue;
    const o = "key" in r && r.key != null ? String(r.key) : void 0, i = "label" in r ? r.label : void 0;
    typeof i == "string" && n.push({ key: o ?? i, label: i }), "children" in r && Array.isArray(r.children) && n.push(...Lt(r.children));
  }
  return n;
}
const Xn = {
  DRAFT: "default",
  POSTED: "processing",
  PAID: "success",
  OVERDUE: "error",
  VOID: "warning",
  ISSUED: "default",
  SENT: "default",
  PART_PAID: "default",
  REFUNDED: "default"
}, Ve = ({ status: t }) => /* @__PURE__ */ e(pe, { color: Xn[t], className: "px-2 text-xs font-medium", children: t }), yi = ({ label: t, color: n, closable: r = !1, onClose: o }) => /* @__PURE__ */ e(pe, { color: n, closable: r, onClose: o, className: "px-2 text-xs font-medium", children: t }), { Text: Zn } = E, ot = (t, n = "ZAR", r = !0, o) => {
  const i = o ?? (typeof navigator < "u" ? navigator.language : "en-US"), l = Number(t), u = Math.abs(l), a = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }, m = new Intl.NumberFormat(i, {
    ...a,
    style: r ? "currency" : "decimal",
    currency: n,
    currencyDisplay: "narrowSymbol"
  }).format(u), h = r ? m : `${m} ${n}`;
  return `${l < 0 ? "−" : ""}${h}`;
}, de = ({
  amount: t,
  currency: n = "ZAR",
  showSymbol: r = !0,
  className: o
}) => {
  const l = Number(t) < 0, u = ot(t, n, r);
  return /* @__PURE__ */ e(Zn, { className: o, type: l ? "danger" : void 0, strong: l, children: u });
};
ae.extend(hn);
const { RangePicker: Jn } = xt, er = () => {
  const t = ae(), n = t.startOf("week"), r = t.endOf("week"), o = t.startOf("month"), i = t.endOf("month"), l = t.month(), u = t.year(), a = l >= 6 ? ae(`${u}-07-01`) : ae(`${u - 1}-07-01`), s = a.add(1, "year").subtract(1, "day");
  return [
    { label: "📅 Today", value: [t, t] },
    {
      label: "📅 This Week",
      value: [n, r]
    },
    {
      label: "📅 This Month",
      value: [o, i]
    },
    { label: "📅 Financial Year", value: [a, s] }
  ];
}, Dt = ({
  value: t,
  onChange: n,
  presets: r = !0,
  allowClear: o = !1,
  disabled: i,
  className: l,
  open: u,
  "data-testid": a
}) => {
  const [s, m] = L([
    t?.[0] ?? null,
    t?.[1] ?? null
  ]);
  re(() => {
    t && m(t);
  }, [t]);
  const h = (C, y) => {
    const b = ((D) => !!D && typeof D == "object" && "range" in D && D.range !== void 0)(y) ? y.range : void 0;
    return b === "start" && s[1] ? C.isAfter(s[1], "day") : b === "end" && s[0] ? C.isBefore(s[0], "day") : !1;
  };
  return /* @__PURE__ */ e(
    Jn,
    {
      value: t ?? s,
      onCalendarChange: (C) => {
        m(C);
      },
      onChange: (C) => {
        if (!C) {
          o && (m([null, null]), n?.([null, null]));
          return;
        }
        let [y, S] = C;
        y && S ? (y.isAfter(S) && ([y, S] = [S, y]), m([y, S]), n?.([y, S])) : o && (m([y ?? null, S ?? null]), n?.([y ?? null, S ?? null]));
      },
      presets: r ? er() : void 0,
      allowClear: o,
      disabled: i,
      className: l,
      disabledDate: h,
      open: u,
      "data-testid": a
    }
  );
}, tr = ({
  x: t,
  y: n,
  width: r,
  height: o,
  payload: i,
  patternId: l,
  colorMap: u,
  onEdit: a,
  highlightColor: s,
  activeId: m,
  setActiveId: h,
  formatDate: f
}) => {
  if (!i || typeof t != "number" || typeof n != "number" || typeof r != "number" || typeof o != "number")
    return null;
  const N = o * 0.6, C = n + (o - N) / 2, y = i.status === "OVERLAP" ? `url(#${l})` : u[i.status], S = /* @__PURE__ */ e(
    "rect",
    {
      x: t,
      y: C,
      width: r,
      height: N,
      fill: y,
      stroke: m === i.id ? s : void 0,
      strokeWidth: m === i.id ? 2 : 0,
      "data-testid": `bar-${i.id}`
    }
  );
  return a ? /* @__PURE__ */ e("foreignObject", { x: t, y: n, width: r, height: o, children: /* @__PURE__ */ e(
    "button",
    {
      style: {
        width: "100%",
        height: "100%",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        position: "relative"
      },
      "aria-label": `${i.itemName} ${ot(i.price, i.currency)} ${f(new Date(i.from))} - ${f(new Date(i.to))} ${i.status}`,
      onClick: () => a(i.id),
      onMouseEnter: () => h(i.id),
      onMouseLeave: () => h(null),
      onFocus: () => h(i.id),
      onBlur: () => h(null),
      children: /* @__PURE__ */ e("svg", { width: "100%", height: "100%", style: { position: "absolute", top: 0, left: 0 }, children: S })
    }
  ) }) : S;
}, bi = ({
  schedules: t,
  onEdit: n,
  height: r = 60,
  className: o,
  showLegend: i = !1,
  groupBySeason: l = !1,
  locale: u,
  dateFormatter: a
}) => {
  const { token: s } = Y.useToken(), m = $t(), [h, f] = L(null), N = ge(
    (p) => a ? a(p) : p.toLocaleDateString(u),
    [a, u]
  ), { data: C, domain: y, domainStart: S } = ee(() => {
    if (t.length === 0)
      return {
        data: [],
        domain: [0, 1],
        domainStart: 0
      };
    const p = [...t].sort(
      (J, ke) => new Date(J.from).getTime() - new Date(ke.from).getTime()
    ), I = p.map((J) => new Date(J.from).getTime()), T = p.map((J) => new Date(J.to).getTime()), x = Math.min(...I), M = Math.max(...T), P = (M - x || 1) * 0.05, te = x - P, X = M + P;
    return {
      data: p.map((J) => ({
        ...J,
        offset: new Date(J.from).getTime() - te,
        duration: new Date(J.to).getTime() - new Date(J.from).getTime()
      })),
      domain: [0, X - te],
      domainStart: te
    };
  }, [t]), b = S + y[1], D = ee(() => {
    const p = (b - S) / 4;
    return Array.from({ length: 5 }, (I, T) => T * p);
  }, [b, S]), g = Date.now() - S, A = g >= 0 && g <= y[1], W = ee(
    () => ({
      ACTIVE: s.colorSuccess,
      FUTURE: s.colorInfo,
      EXPIRED: s.colorTextDisabled,
      OVERLAP: s.colorError
    }),
    [s]
  ), q = ee(() => {
    if (!l)
      return [];
    const p = /* @__PURE__ */ new Map();
    return C.forEach((I) => {
      const T = new Date(I.from).getFullYear().toString(), x = I.offset, M = I.offset + I.duration, B = p.get(T);
      B ? (B.start = Math.min(B.start, x), B.end = Math.max(B.end, M)) : p.set(T, { start: x, end: M });
    }), Array.from(p.entries()).map(([I, T]) => ({
      season: I,
      start: T.start,
      end: T.end
    }));
  }, [l, C]), w = ge(
    (p) => /* @__PURE__ */ e(
      tr,
      {
        ...p,
        patternId: m,
        colorMap: W,
        onEdit: n,
        highlightColor: s.colorPrimaryHover,
        activeId: h,
        setActiveId: f,
        formatDate: N
      }
    ),
    [m, W, n, h, f, s.colorPrimaryHover, N]
  );
  if (t.length === 0)
    return /* @__PURE__ */ e(Vt, { className: o });
  const F = t.some((p) => p.status === "OVERLAP"), H = ({ active: p, payload: I }) => {
    if (p && I?.length) {
      const T = I[0].payload, x = new Date(T.from).getFullYear().toString();
      return /* @__PURE__ */ c("div", { style: { padding: 8 }, children: [
        l && /* @__PURE__ */ c("div", { style: { fontStyle: "italic" }, children: [
          "Season ",
          x
        ] }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("strong", { children: T.itemName }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(de, { amount: T.price, currency: T.currency }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c("span", { children: [
          N(new Date(T.from)),
          " - ",
          N(new Date(T.to))
        ] }) }),
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(Ve, { status: ut(T.status) }) })
      ] });
    }
    return null;
  };
  return /* @__PURE__ */ c("div", { className: o, style: { width: "100%", height: r }, children: [
    F && /* @__PURE__ */ e(Ve, { status: ut("OVERLAP") }),
    /* @__PURE__ */ e(pn, { width: "100%", height: "100%", children: /* @__PURE__ */ c(gn, { data: C, margin: { top: 0, right: 0, left: 0, bottom: 0 }, barCategoryGap: 0, children: [
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ c(
        "pattern",
        {
          id: m,
          patternUnits: "userSpaceOnUse",
          width: 8,
          height: 8,
          patternTransform: "rotate(45)",
          children: [
            /* @__PURE__ */ e("rect", { x: "0", y: "0", width: "8", height: "8", fill: s.colorErrorBg }),
            /* @__PURE__ */ e("line", { x1: "0", y1: "0", x2: "0", y2: "8", stroke: s.colorError, strokeWidth: "2" })
          ]
        }
      ) }),
      /* @__PURE__ */ e(
        fn,
        {
          dataKey: "offset",
          type: "number",
          domain: y,
          ticks: D,
          tickFormatter: (p) => N(new Date(S + p)),
          tick: { fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(yn, { hide: !0 }),
      /* @__PURE__ */ e(bn, { content: H }),
      l && q.map((p) => /* @__PURE__ */ e(
        st,
        {
          x: (p.start + p.end) / 2,
          stroke: "none",
          label: { position: "top", value: p.season, fontSize: 10 }
        },
        p.season
      )),
      A && /* @__PURE__ */ e(
        st,
        {
          x: g,
          stroke: s.colorWarning,
          strokeDasharray: "3 3",
          label: { position: "top", value: "Today", fontSize: 10 }
        }
      ),
      /* @__PURE__ */ e(
        Sn,
        {
          dataKey: "duration",
          minPointSize: 2,
          isAnimationActive: !1,
          shape: w
        }
      )
    ] }) }),
    i && /* @__PURE__ */ e(
      "section",
      {
        className: "mt-1 flex flex-wrap gap-2 text-xs",
        "data-testid": "legend",
        "aria-label": "Chart legend",
        children: Object.entries(W).map(
          ([p, I]) => /* @__PURE__ */ c("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "inline-block w-3 h-3 rounded-sm border",
                style: { backgroundColor: I, borderColor: I },
                "data-testid": `legend-swatch-${p}`
              }
            ),
            /* @__PURE__ */ e("span", { children: p })
          ] }, p)
        )
      }
    )
  ] });
};
function ut(t) {
  switch (t) {
    case "ACTIVE":
      return "ISSUED";
    case "FUTURE":
      return "DRAFT";
    case "EXPIRED":
      return "VOID";
    case "OVERLAP":
      return "OVERDUE";
    default:
      return "DRAFT";
  }
}
const It = (t) => /* @__PURE__ */ e(jt, { destroyOnClose: !0, ...t }), Si = ({
  open: t,
  items: n,
  existing: r,
  onCreate: o,
  onClose: i,
  drawerWidth: l = 500
}) => {
  const { message: u } = Se.useApp(), [a, s] = L(0), [m, h] = L(), [f, N] = L(null), [C, y] = L(0), [S, b] = L("ZAR"), [D, g] = L(!1);
  re(() => {
    t || (s(0), h(void 0), N(null), y(0), b("ZAR"), g(!1));
  }, [t]);
  const A = n.find((T) => T.id === m), W = f ? f[0].isAfter(f[1]) : !1, w = (() => {
    if (!f || !A) return !1;
    const [T, x] = f;
    return r.filter((M) => M.itemName === A.name).some((M) => {
      const B = ae(M.from), P = ae(M.to);
      return !B.isAfter(x) && !P.isBefore(T);
    });
  })(), F = !!m, H = !!f && !W && !w, p = async () => {
    if (!(!A || !f)) {
      g(!0);
      try {
        const [T, x] = f, M = {
          itemName: A.name,
          from: T.toISOString(),
          to: x.toISOString(),
          price: C,
          currency: S,
          id: "",
          status: "FUTURE"
        };
        await Promise.resolve(o(M)), i();
      } catch (T) {
        u.error(d("en-US", "createError")), console.error(T);
      } finally {
        g(!1);
      }
    }
  }, I = [
    /* @__PURE__ */ e(nr, { items: n, itemId: m, onChange: h }, "step1"),
    /* @__PURE__ */ e(
      rr,
      {
        dates: f,
        onChange: (T) => N(T),
        rangeInvalid: W,
        overlap: w
      },
      "step2"
    ),
    /* @__PURE__ */ e(
      or,
      {
        item: A?.name ?? "",
        dates: f,
        price: C,
        currency: S,
        onPriceChange: y,
        onCurrencyChange: b
      },
      "step3"
    ),
    /* @__PURE__ */ e(
      ir,
      {
        item: A?.name ?? "",
        dates: f,
        price: C,
        currency: S
      },
      "review"
    )
  ];
  return /* @__PURE__ */ c(It, { open: t, onClose: i, size: l, children: [
    /* @__PURE__ */ e(
      et,
      {
        current: a,
        style: { marginBottom: 24 },
        items: [
          { title: d("en-US", "itemLabel") },
          { title: d("en-US", "dateRangeLabel") },
          { title: d("en-US", "priceLabel") },
          { title: d("en-US", "reviewLabel") }
        ]
      }
    ),
    I[a],
    /* @__PURE__ */ c(V, { style: { marginTop: 24 }, children: [
      a > 0 && /* @__PURE__ */ e(U, { onClick: () => s(a - 1), children: d("en-US", "backAction") }),
      /* @__PURE__ */ c(V, { style: { marginLeft: "auto" }, children: [
        a < 3 && /* @__PURE__ */ e(
          U,
          {
            type: "primary",
            onClick: () => s(a + 1),
            disabled: a === 0 ? !F : a === 1 ? !H : !1,
            children: d("en-US", "nextAction")
          }
        ),
        a === 3 && /* @__PURE__ */ e(
          U,
          {
            type: "primary",
            onClick: p,
            "data-testid": "create-btn",
            loading: D,
            children: d("en-US", "createAction")
          }
        ),
        /* @__PURE__ */ e(U, { onClick: i, children: d("en-US", "cancelAction") })
      ] })
    ] })
  ] });
}, nr = ({ items: t, itemId: n, onChange: r }) => /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: d("en-US", "itemLabel"), required: !0, children: /* @__PURE__ */ e(
  Ue,
  {
    showSearch: !0,
    placeholder: d("en-US", "selectItem"),
    optionFilterProp: "label",
    style: { width: "100%" },
    value: n,
    onChange: r,
    options: t.map((o) => ({ value: o.id, label: o.name }))
  }
) }) }), rr = ({ dates: t, onChange: n, rangeInvalid: r, overlap: o }) => {
  const i = ae();
  return /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(
    v.Item,
    {
      label: d("en-US", "dateRangeLabel"),
      validateStatus: r || o ? "error" : "",
      help: r ? d("en-US", "startBeforeEnd") : o ? d("en-US", "scheduleOverlap") : void 0,
      children: /* @__PURE__ */ c(V, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
        /* @__PURE__ */ e(V, { size: "small", children: /* @__PURE__ */ c(U, { type: "link", onClick: () => n([i, i]), children: [
          /* @__PURE__ */ e("span", { role: "img", "aria-label": "calendar", children: "📅" }),
          " ",
          d("en-US", "today")
        ] }) }),
        /* @__PURE__ */ e(Dt, { value: t ?? void 0, onChange: n })
      ] })
    }
  ) });
}, or = ({
  item: t,
  dates: n,
  price: r,
  currency: o,
  onPriceChange: i,
  onCurrencyChange: l
}) => /* @__PURE__ */ c(v, { layout: "vertical", children: [
  /* @__PURE__ */ c(E.Text, { children: [
    t,
    " — ",
    n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : ""
  ] }),
  /* @__PURE__ */ e(v.Item, { label: d("en-US", "priceLabel"), children: /* @__PURE__ */ e(
    tt,
    {
      value: r,
      onChange: (u) => i(u != null ? Number(u) : 0),
      min: 0,
      style: { width: "100%" }
    }
  ) }),
  /* @__PURE__ */ e(v.Item, { label: d("en-US", "currencyLabel"), children: /* @__PURE__ */ e(
    Ue,
    {
      value: o,
      onChange: l,
      options: [
        { value: "ZAR", label: "ZAR" },
        { value: "USD", label: "USD" },
        { value: "EUR", label: "EUR" }
      ]
    }
  ) }),
  /* @__PURE__ */ e(de, { amount: r, currency: o })
] }), ir = ({ item: t, dates: n, price: r, currency: o }) => /* @__PURE__ */ c(V, { orientation: "vertical", style: { width: "100%" }, size: "middle", children: [
  /* @__PURE__ */ e(E.Text, { strong: !0, children: t }),
  /* @__PURE__ */ e(E.Text, { children: n ? `${n[0].format("YYYY-MM-DD")} - ${n[1].format("YYYY-MM-DD")}` : "" }),
  /* @__PURE__ */ e(de, { amount: r, currency: o })
] }), ar = "startBeforeEnd", lr = "scheduleOverlap", mt = (t, n, r) => n && t.isAfter(n) ? ar : r(t, n) ? lr : null, sr = [
  { label: "ZAR", value: "ZAR" },
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" }
], cr = vn.string().length(3, "Invalid currency code").regex(/^[A-Za-z]{3}$/, "Invalid currency code").transform((t) => t.toUpperCase()), vi = ({
  visible: t,
  schedule: n,
  otherSchedules: r,
  onSave: o,
  onCancel: i,
  onDelete: l
}) => {
  const [u] = v.useForm(), [a, s] = L(null);
  re(() => {
    t && u.setFieldsValue({
      itemName: n.itemName,
      range: [ae(n.from), n.to ? ae(n.to) : null],
      price: n.price,
      currency: n.currency ?? "ZAR"
    });
  }, [t, n, u]);
  const m = (y, S) => r?.length ? r.some((b) => {
    if (b.id === n.id) return !1;
    const D = ae(b.from), g = b.to ? ae(b.to) : null, A = !g || y.isBefore(g) || y.isSame(g), W = !S || D.isBefore(S) || D.isSame(S);
    return A && W;
  }) : !1, h = () => {
    const [y, S] = u.getFieldValue("range");
    if (!y || S === void 0) {
      s(null);
      return;
    }
    s(mt(y, S, m));
  }, f = async () => {
    try {
      const y = await u.validateFields(), [S, b] = y.range, D = mt(S, b, m);
      if (D) {
        s(D);
        return;
      }
      const g = cr.safeParse(y.currency);
      if (!g.success) {
        u.setFields([{ name: "currency", errors: [g.error.issues[0].message] }]);
        return;
      }
      o({
        ...n,
        itemName: y.itemName,
        from: S.toISOString(),
        to: b ? b.toISOString() : "",
        price: y.price,
        currency: g.data
      }), u.resetFields(), s(null);
    } catch {
    }
  }, N = () => {
    u.resetFields(), s(null), i();
  }, C = () => {
    l && (l(n.id), u.resetFields(), s(null));
  };
  return /* @__PURE__ */ e(
    Ee,
    {
      title: d("en-US", "editPriceScheduleTitle"),
      open: t,
      onOk: f,
      onCancel: N,
      okText: d("en-US", "saveAction"),
      cancelText: d("en-US", "cancelAction"),
      footer: (y, { OkBtn: S, CancelBtn: b }) => /* @__PURE__ */ c(V, { style: { display: "flex", justifyContent: "space-between", width: "100%" }, children: [
        l ? /* @__PURE__ */ e(
          Gt,
          {
            title: d("en-US", "deleteConfirmTitle"),
            description: d("en-US", "deleteScheduleConfirmMessage"),
            onConfirm: C,
            okText: d("en-US", "deleteAction"),
            cancelText: d("en-US", "cancelAction"),
            okButtonProps: { danger: !0 },
            children: /* @__PURE__ */ e(U, { danger: !0, icon: /* @__PURE__ */ e(kt, {}), "data-testid": "delete-btn", children: d("en-US", "deleteAction") })
          }
        ) : /* @__PURE__ */ e("div", {}),
        /* @__PURE__ */ c(V, { children: [
          /* @__PURE__ */ e(b, {}),
          /* @__PURE__ */ e(S, {})
        ] })
      ] }),
      children: /* @__PURE__ */ c(v, { form: u, layout: "vertical", onFieldsChange: h, children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "itemName",
            label: d("en-US", "itemLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(z, { "data-testid": "itemName" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "range",
            label: d("en-US", "dateRangeLabel"),
            rules: [{ required: !0 }],
            validateStatus: a ? "error" : void 0,
            help: a ? d("en-US", a) : void 0,
            children: /* @__PURE__ */ e(Dt, { "data-testid": "range" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "price",
            label: d("en-US", "priceLabel"),
            rules: [{ required: !0, type: "number", min: 0 }],
            children: /* @__PURE__ */ e(tt, { "data-testid": "price", style: { width: "100%" } })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "currency",
            label: d("en-US", "currencyLabel"),
            rules: [{ required: !0 }],
            children: /* @__PURE__ */ e(Ue, { options: sr, "data-testid": "currency" })
          }
        )
      ] })
    }
  );
}, Ke = (t, n = 1) => t.map((r, o, i) => ({
  key: r.id,
  title: r.title,
  children: r.children ? Ke(r.children, n + 1) : void 0,
  ariaLevel: n,
  ariaPosinset: o + 1,
  ariaSetsize: i.length
})), ve = (t) => t.map((n) => ({
  id: String(n.key),
  title: typeof n.title == "string" ? n.title : "",
  children: n.children ? ve(n.children) : void 0
})), ze = (t) => t.map((n) => ({
  ...n,
  children: n.children ? ze(n.children) : void 0
})), Mt = (t, n, r) => t.map((o) => {
  if (o.key === n)
    return { ...o, title: r };
  if (o.children) {
    const i = Mt(o.children, n, r);
    if (i !== o.children)
      return { ...o, children: i };
  }
  return o;
}), Ut = (t) => !t.children || t.children.length === 0 ? 1 : 1 + Math.max(...t.children.map(Ut)), Oe = (t) => t.length === 0 ? 0 : Math.max(...t.map(Ut)), wi = (t) => {
  const n = [], r = (o) => {
    o.forEach((i) => {
      n.push({ id: i.id, title: i.title }), i.children && r(i.children);
    });
  };
  return r(t), n;
}, Et = (t, n) => {
  if (!n) return t;
  const r = n.toLowerCase();
  return t.map((o) => {
    const i = o.children ? Et(o.children, n) : [];
    return String(o.title).toLowerCase().includes(r) || i.length ? { ...o, children: i } : null;
  }).filter(Boolean);
}, we = (t, n, r = null) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return { parent: t, index: o, parentNode: r };
    const l = i.children;
    if (l) {
      const u = we(l, n, i);
      if (u) return u;
    }
  }
  return null;
}, Qe = (t, n, r) => {
  for (let o = 0; o < t.length; o++) {
    const i = t[o];
    if (i.key === n)
      return r?.(i, o, t), i;
    if (i.children) {
      const l = Qe(i.children, n, r);
      if (l) return l;
    }
  }
  return null;
}, Xe = (t, n) => {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (o.key === n)
      return t.splice(r, 1)[0];
    const i = o.children;
    if (i) {
      const l = Xe(i, n);
      if (l) return l;
    }
  }
  return null;
}, ht = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r;
  return [o[i - 1], o[i]] = [o[i], o[i - 1]], !0;
}, pt = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === r.parent.length - 1) return !1;
  const { parent: o, index: i } = r;
  return [o[i], o[i + 1]] = [o[i + 1], o[i]], !0;
}, gt = (t, n) => {
  const r = we(t, n);
  if (!r || r.index === 0) return !1;
  const { parent: o, index: i } = r, l = o[i - 1], u = o.splice(i, 1)[0];
  return l.children = l.children || [], l.children.push(u), !0;
}, ft = (t, n) => {
  const r = we(t, n);
  if (!r || !r.parentNode) return !1;
  const { parent: o, index: i, parentNode: l } = r, u = we(t, l.key);
  if (!u) return !1;
  const a = o.splice(i, 1)[0];
  return u.parent.splice(u.index + 1, 0, a), !0;
}, dr = () => typeof globalThis.crypto?.randomUUID == "function" ? globalThis.crypto.randomUUID() : Math.random().toString(36).slice(2), ur = -1e4, mr = -1e4, xi = (t) => {
  const {
    data: n,
    onChange: r,
    className: o,
    maxDepth: i,
    depthErrorMessage: l
  } = t, u = i ?? 4, a = l ?? `Max depth exceeded (limit: ${u})`, { __testOpenMenuForKey: s, __testRenderMenu: m, __testOnFilteredTree: h } = t, [f, N] = L(() => Ke(n)), [C, y] = L(""), [S, b] = L(!1), [D, g] = L(null), [A, W] = L(null), [q, w] = L(null), [F, H] = L(""), [p, I] = L(null), { token: T } = Y.useToken(), x = De(null), M = De(null), B = ee(() => {
    const k = [], R = (G) => {
      G.forEach((ce) => {
        k.push(ce.key), ce.children && R(ce.children);
      });
    };
    return R(f), k;
  }, [f]), P = ee(() => Et(f, C), [f, C]);
  re(() => {
    h?.(P);
  }, [h, P]), re(() => (N(Ke(n)), () => {
    x.current && clearTimeout(x.current);
  }), [n]), re(() => {
    if (!(typeof s > "u")) {
      if (s) {
        I({ x: 0, y: 0, key: s });
        return;
      }
      I(null);
    }
  }, [s]);
  const te = ge(() => {
    b(!0), x.current = setTimeout(() => b(!1), 3e3);
  }, []), X = ge(
    (k) => {
      if (!A) return;
      const R = ze(f);
      if (k(R, A)) {
        if (Oe(ve(R)) > u) {
          te();
          return;
        }
        N(R), r(ve(R));
      }
    },
    [A, f, u, r, te]
  ), Ne = ge(
    (k) => {
      if (!(!k.ctrlKey || !A))
        switch (k.key) {
          case "ArrowUp":
            X(ht);
            break;
          case "ArrowDown":
            X(pt);
            break;
          case "ArrowRight":
            X(gt);
            break;
          case "ArrowLeft":
            X(ft);
            break;
        }
    },
    [A, X]
  ), J = ge(
    (k, R) => {
      const G = Mt(f, k, R.trim() || "Untitled");
      w(null), N(G), r(ve(G));
    },
    [f, r]
  ), ke = (k) => {
    const { node: R } = k;
    M.current = R;
  }, Fe = () => {
    M.current = null;
  }, se = (k) => {
    const { node: R } = k, G = M.current ? Oe(ve([M.current])) : 1, ne = String(R.pos).split("-").length - 1 + G;
    g(ne > u ? String(R.key) : null);
  }, Pe = (k) => {
    const R = k.node.key, G = k.dragNode.key, ce = k.node.pos.split("-"), ne = k.dropPosition - Number(ce.at(-1)), ue = ze(f), fe = Xe(ue, G);
    if (!fe) return;
    if (k.dropToGap) {
      const ye = we(ue, R);
      if (!ye) return;
      const { parent: Re, index: $e } = ye;
      Re.splice(ne === -1 ? $e : $e + 1, 0, fe);
    } else {
      const ye = Qe(ue, R);
      if (!ye) return;
      ye.children ??= [], ye.children.unshift(fe);
    }
    const Te = ve(ue);
    if (Oe(Te) > u) {
      te(), g(R);
      return;
    }
    g(null), N(ue), r(Te);
  }, Be = (k) => {
    k.event.preventDefault(), I({
      x: k.event.pageX,
      y: k.event.pageY,
      key: String(k.node.key)
    });
  }, Ce = ({ key: k }) => {
    if (!p) return;
    const R = p.key, G = ze(f);
    if (k === "add") {
      const ne = Qe(G, R);
      if (!ne) return;
      const ue = {
        key: dr(),
        title: "New node",
        ariaLevel: ne.ariaLevel + 1,
        ariaPosinset: (ne.children?.length ?? 0) + 1,
        ariaSetsize: (ne.children?.length ?? 0) + 1
      };
      ne.children = [...ne.children ?? [], ue], ne.children.forEach((fe, Te) => {
        fe.ariaPosinset = Te + 1, fe.ariaSetsize = ne.children ? ne.children.length : 0;
      });
    } else k === "delete" && Xe(G, R);
    const ce = ve(G);
    if (Oe(ce) > u) {
      te(), g(R), I(null);
      return;
    }
    g(null), N(G), r(ce), I(null);
  };
  re(() => {
    if (!p)
      return;
    const k = () => I(null);
    return document.addEventListener("mousedown", k), () => {
      document.removeEventListener("mousedown", k);
    };
  }, [p]);
  const ie = ee(() => {
    const k = (R) => R.map((G) => ({
      ...G,
      className: G.key === D ? "text-red-500" : void 0,
      children: G.children ? k(G.children) : void 0
    }));
    return k(P);
  }, [P, D]);
  return /* @__PURE__ */ c(be, { children: [
    /* @__PURE__ */ e(
      z,
      {
        placeholder: "Filter…",
        allowClear: !0,
        prefix: /* @__PURE__ */ e(on, {}),
        style: { marginBottom: 8 },
        value: C,
        onChange: (k) => y(k.target.value)
      }
    ),
    S && /* @__PURE__ */ e(
      We,
      {
        type: "error",
        message: a,
        closable: !0,
        showIcon: !0,
        style: { marginBottom: 8 }
      }
    ),
    /* @__PURE__ */ e(
      Yt,
      {
        className: o,
        blockNode: !0,
        draggable: !0,
        expandedKeys: B,
        autoExpandParent: !0,
        treeData: ie,
        onSelect: (k) => W(String(k[0])),
        onKeyDown: Ne,
        onDragStart: ke,
        onDragEnd: Fe,
        onDragOver: se,
        onDrop: Pe,
        onRightClick: Be,
        titleRender: (k) => q === k.key ? /* @__PURE__ */ e(
          z,
          {
            size: "small",
            autoFocus: !0,
            value: F,
            onChange: (R) => H(R.target.value),
            onBlur: () => J(String(k.key), F),
            onPressEnter: () => J(String(k.key), F),
            onKeyDown: (R) => R.stopPropagation()
          }
        ) : /* @__PURE__ */ e(
          "span",
          {
            onDoubleClick: () => {
              w(String(k.key)), H(String(k.title));
            },
            className: String(k.className || ""),
            children: String(k.title)
          }
        )
      }
    ),
    /* @__PURE__ */ c("div", { style: { marginTop: 8 }, children: [
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Move up",
          size: "small",
          disabled: !A,
          onClick: () => X(ht),
          children: "↑"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Move down",
          size: "small",
          disabled: !A,
          onClick: () => X(pt),
          style: { marginLeft: 4 },
          children: "↓"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Indent",
          size: "small",
          disabled: !A,
          onClick: () => X(gt),
          style: { marginLeft: 4 },
          children: "↪"
        }
      ),
      /* @__PURE__ */ e(
        U,
        {
          "aria-label": "Outdent",
          size: "small",
          disabled: !A,
          onClick: () => X(ft),
          style: { marginLeft: 4 },
          children: "↩"
        }
      )
    ] }),
    p && /* @__PURE__ */ c(
      "div",
      {
        role: "menu",
        "aria-label": "Node actions",
        onMouseDown: (k) => k.stopPropagation(),
        style: {
          position: "absolute",
          left: p.x,
          top: p.y,
          background: T.colorBgElevated,
          border: `1px solid ${T.colorBorder}`,
          borderRadius: T.borderRadiusLG,
          boxShadow: T.boxShadowSecondary,
          display: "flex",
          flexDirection: "column",
          minWidth: 160,
          zIndex: T.zIndexPopupBase
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => Ce({ key: "add" }),
              style: {
                padding: `${T.paddingXS}px ${T.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => Ce({ key: "delete" }),
              style: {
                padding: `${T.paddingXS}px ${T.paddingSM}px`,
                textAlign: "left",
                background: "transparent",
                border: "none",
                cursor: "pointer"
              },
              children: "Delete"
            }
          )
        ]
      }
    ),
    m && p && /* @__PURE__ */ c(
      "div",
      {
        "data-testid": "classification-tree__test-menu",
        style: {
          position: "absolute",
          left: ur,
          top: mr
        },
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => Ce({ key: "add" }),
              children: "Add child"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: () => Ce({ key: "delete" }),
              children: "Delete"
            }
          )
        ]
      }
    )
  ] });
}, ki = ({
  currency: t = "ZAR",
  style: n,
  onChange: r,
  ...o
}) => /* @__PURE__ */ e(
  tt,
  {
    step: 0.01,
    style: { width: "100%", ...n },
    formatter: (i) => i == null ? "" : `${ot(i, t, !1)} ${t}`,
    parser: (i) => Number(String(i).replace(/[A-Za-z\s,]+/g, "")),
    onChange: (i) => r?.(typeof i == "number" ? i : null),
    ...o
  }
), Ci = ({
  balance: t = null,
  adjustments: n = []
}) => {
  const [r, o] = L(t), [i, l] = L(n ?? []), u = ee(
    () => (i ?? []).filter((s) => s.amount > 0),
    [i]
  ), a = ee(
    () => (i ?? []).filter((s) => s.amount < 0),
    [i]
  );
  return re(() => {
    if (t !== null || n && n.length > 0) {
      o(t), l(n ?? []);
      return;
    }
    (async () => {
      try {
        const m = await fetch("/api/stripe/balance");
        if (!m.ok)
          throw new Error("Failed to fetch balance");
        const h = await m.json();
        o(h.balance), l(Array.isArray(h.adjustments) ? h.adjustments : []);
      } catch (m) {
        console.error(m);
      }
    })();
  }, [t, n]), /* @__PURE__ */ c(_e, { title: "Current Balance", bordered: !1, "data-testid": "balance-card", children: [
    /* @__PURE__ */ e("div", { "data-testid": "current-balance", children: r !== null ? (r / 100).toFixed(2) : "Loading..." }),
    /* @__PURE__ */ c("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Credits" }),
      u.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: u.map((s) => /* @__PURE__ */ c(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: s.description ?? s.type }),
            /* @__PURE__ */ e("span", { children: (s.amount / 100).toFixed(2) })
          ]
        },
        s.id
      )) })
    ] }),
    /* @__PURE__ */ c("div", { style: { marginTop: 12 }, children: [
      /* @__PURE__ */ e("div", { children: "Debits" }),
      a.length === 0 ? /* @__PURE__ */ e("div", { children: "None" }) : /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 6 }, children: a.map((s) => /* @__PURE__ */ c(
        "div",
        {
          role: "listitem",
          "data-testid": "adjustment-item",
          style: {
            display: "flex",
            justifyContent: "space-between",
            padding: "6px 0",
            borderBottom: "1px solid #f0f0f0"
          },
          children: [
            /* @__PURE__ */ e("div", { children: s.description ?? s.type }),
            /* @__PURE__ */ e("span", { children: (s.amount / 100).toFixed(2) })
          ]
        },
        s.id
      )) })
    ] })
  ] });
}, Ti = ({ invoices: t, groupBySeason: n = !1 }) => {
  const [r, o] = L("ALL"), i = r === "ALL" ? t : t.filter((s) => s.status === r), l = ee(() => n ? i.reduce(
    (s, m) => {
      const h = m.period.match(/(\d{4})/), f = h ? h[1] : "Unknown";
      return s[f] || (s[f] = []), s[f].push(m), s;
    },
    {}
  ) : { All: i }, [i, n]), u = [
    {
      title: "Invoice #",
      dataIndex: "id",
      sorter: (s, m) => s.id.localeCompare(m.id)
    },
    {
      title: "Period",
      dataIndex: "period",
      sorter: (s, m) => s.period.localeCompare(m.period)
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (s, m) => s.amount - m.amount,
      render: (s, m) => /* @__PURE__ */ c(V, { orientation: "vertical", children: [
        /* @__PURE__ */ e(de, { amount: s }),
        m.paidBy && /* @__PURE__ */ e(E.Text, { type: "secondary", children: `Paid by ${m.paidBy}` })
      ] })
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (s, m) => s.status.localeCompare(m.status),
      render: (s) => /* @__PURE__ */ e(Ve, { status: s })
    },
    {
      title: "Download PDF",
      dataIndex: "pdfUrl",
      render: (s, m) => /* @__PURE__ */ e("a", { href: s, "aria-label": `Download invoice ${m.id}`, children: "PDF" })
    }
  ], a = Array.from(new Set(t.map((s) => s.status)));
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e(
      Ue,
      {
        placeholder: "Status",
        value: r === "ALL" ? void 0 : r,
        allowClear: !0,
        onChange: (s) => o(s ?? "ALL"),
        style: { width: 160, marginBottom: 16 },
        children: a.map((s) => /* @__PURE__ */ e(Ue.Option, { value: s, children: s }, s))
      }
    ),
    Object.entries(l).map(([s, m]) => /* @__PURE__ */ c(
      "div",
      {
        "data-testid": `season-${s}`,
        style: { marginBottom: n ? 16 : 0 },
        children: [
          n && /* @__PURE__ */ e(E.Title, { level: 5, style: { marginTop: 0 }, children: s }),
          /* @__PURE__ */ e(K, { rowKey: "id", columns: u, dataSource: m, pagination: !1 })
        ]
      },
      s
    ))
  ] });
}, hr = "_invoiceModal_djzrq_1", pr = "_fullWidth_djzrq_5", gr = "_summaryCell_djzrq_8", fr = "_notesDivider_djzrq_17", yr = "_notesParagraph_djzrq_21", he = {
  invoiceModal: hr,
  fullWidth: pr,
  summaryCell: gr,
  notesDivider: fr,
  notesParagraph: yr
}, br = ({ invoice: t }) => /* @__PURE__ */ c(K.Summary, { children: [
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Sub-total" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: he.summaryCell, children: /* @__PURE__ */ e(de, { amount: t.subTotal, currency: t.currency }) })
  ] }),
  t.discount !== void 0 && /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Discount" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: he.summaryCell, children: /* @__PURE__ */ e(de, { amount: t.discount, currency: t.currency }) })
  ] }),
  t.otherCharges !== void 0 && /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "Other Charges" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: he.summaryCell, children: /* @__PURE__ */ e(de, { amount: t.otherCharges, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: "VAT" }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: he.summaryCell, children: /* @__PURE__ */ e(de, { amount: t.vat, currency: t.currency }) })
  ] }),
  /* @__PURE__ */ c(K.Summary.Row, { children: [
    /* @__PURE__ */ e(K.Summary.Cell, { index: 0, colSpan: 3, align: "right", children: /* @__PURE__ */ e(E.Text, { strong: !0, children: "Grand Total" }) }),
    /* @__PURE__ */ e(K.Summary.Cell, { index: 3, align: "right", className: he.summaryCell, children: /* @__PURE__ */ e(de, { amount: t.grandTotal, currency: t.currency }) })
  ] })
] }), _i = ({
  visible: t,
  invoice: n,
  onClose: r,
  onDownloadPdf: o,
  onDelete: i
}) => {
  const [l, u] = j.useState(null), a = [
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Qty", dataIndex: "qty", key: "qty", align: "right" },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      render: (m) => /* @__PURE__ */ e(de, { amount: m, currency: n.currency }),
      align: "right"
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (m) => /* @__PURE__ */ e(de, { amount: m, currency: n.currency }),
      align: "right"
    },
    {
      title: "Delete",
      key: "delete",
      align: "center",
      render: (m, h) => /* @__PURE__ */ e(
        U,
        {
          icon: /* @__PURE__ */ e(kt, {}),
          "aria-label": "Delete line",
          onClick: () => u(h.id)
        }
      )
    }
  ], s = () => {
    typeof window < "u" && typeof window.print == "function" && window.print();
  };
  return /* @__PURE__ */ c(be, { children: [
    /* @__PURE__ */ e(
      Ee,
      {
        title: null,
        open: t,
        onCancel: r,
        footer: null,
        width: 720,
        rootClassName: he.invoiceModal,
        destroyOnClose: !0,
        children: /* @__PURE__ */ c(V, { orientation: "vertical", className: he.fullWidth, size: "middle", children: [
          /* @__PURE__ */ c(V, { align: "center", wrap: !0, children: [
            /* @__PURE__ */ e(rt, { size: "small" }),
            /* @__PURE__ */ e(E.Text, { strong: !0, children: n.memberName }),
            /* @__PURE__ */ e(E.Text, { children: "-" }),
            /* @__PURE__ */ e(E.Text, { children: n.invoiceNumber }),
            /* @__PURE__ */ e(Ve, { status: n.status })
          ] }),
          /* @__PURE__ */ c(le, { column: 1, size: "small", children: [
            /* @__PURE__ */ e(le.Item, { label: "Issuer", children: n.issuerAddress }),
            /* @__PURE__ */ e(le.Item, { label: "Recipient", children: n.recipientAddress }),
            /* @__PURE__ */ e(le.Item, { label: "Issue Date", children: ae(n.issueDate).format("YYYY-MM-DD") }),
            /* @__PURE__ */ e(le.Item, { label: "Due Date", children: ae(n.dueDate).format("YYYY-MM-DD") })
          ] }),
          /* @__PURE__ */ e(
            K,
            {
              rowKey: "id",
              dataSource: n.lines,
              columns: a,
              pagination: !1,
              size: "small",
              summary: () => /* @__PURE__ */ e(br, { invoice: n })
            }
          ),
          n.notes && /* @__PURE__ */ c(be, { children: [
            /* @__PURE__ */ e(Kt, { className: he.notesDivider }),
            /* @__PURE__ */ e(E.Paragraph, { className: he.notesParagraph, children: n.notes })
          ] }),
          /* @__PURE__ */ c(Ye, { justify: "space-between", align: "middle", className: he.fullWidth, children: [
            /* @__PURE__ */ e(qe, { children: o && /* @__PURE__ */ e(
              U,
              {
                icon: /* @__PURE__ */ e(an, {}),
                onClick: () => o(n.id),
                "aria-label": "Download PDF",
                children: "Download PDF"
              }
            ) }),
            /* @__PURE__ */ e(qe, { children: /* @__PURE__ */ c(V, { children: [
              /* @__PURE__ */ e(U, { icon: /* @__PURE__ */ e(ln, {}), onClick: s, "aria-label": "Print", children: "Print" }),
              /* @__PURE__ */ e(U, { type: "primary", onClick: r, "aria-label": "Close invoice preview", children: "Close" })
            ] }) })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ e(
      Ee,
      {
        open: l !== null,
        title: "Delete line?",
        onOk: () => {
          l && i?.(l), u(null);
        },
        onCancel: () => u(null),
        okText: "Delete",
        cancelText: "Cancel",
        children: /* @__PURE__ */ e(E.Paragraph, { children: "Are you sure you want to remove this line item from the invoice?" })
      }
    )
  ] });
}, Ni = ({ data: t = [] }) => {
  const n = Array.isArray(t) ? t : [];
  return /* @__PURE__ */ e(_e, { title: "Feature Usage", bordered: !1, children: /* @__PURE__ */ e("div", { role: "list", style: { display: "flex", flexDirection: "column", gap: 8 }, children: (n.length ? n : [{ feature: "N/A", count: 0 }]).map(({ feature: r, count: o }) => /* @__PURE__ */ c(
    "div",
    {
      role: "listitem",
      style: {
        display: "flex",
        justifyContent: "space-between",
        padding: "6px 0",
        borderBottom: "1px solid #f0f0f0"
      },
      children: [
        /* @__PURE__ */ e("div", { children: r }),
        /* @__PURE__ */ e("div", { children: o })
      ]
    },
    r
  )) }) });
}, Ai = ({ data: t = [] }) => /* @__PURE__ */ e(_e, { title: "System Health", bordered: !1, children: t.length ? t.map(({ name: n, value: r }) => /* @__PURE__ */ c("div", { style: { marginBottom: 8 }, children: [
  /* @__PURE__ */ e("div", { children: n }),
  /* @__PURE__ */ e(Qt, { percent: r, size: "small" })
] }, n)) : /* @__PURE__ */ e("div", { children: "No data" }) }), Sr = new Cn(), vr = (t) => wn({
  mutationKey: ["tenantsControllerCreateTenant"],
  mutationFn: (n) => Sr.tenantsControllerCreateTenant(
    n[0],
    n[1]
  ).then(({ data: r }) => r),
  ...t
}), Li = ({
  open: t,
  onClose: n,
  initialStep: r = 0
}) => {
  const [o, i] = L(r), [l, u] = L({
    name: "",
    email: ""
  }), [a, s] = L(), [m, h] = L([]), f = vr(), N = o === 0 && !l.name || o === 1 && !a, C = async () => {
    try {
      const y = { name: l.name };
      await f.mutateAsync([y]), n();
    } catch {
    }
  };
  return /* @__PURE__ */ c(It, { open: t, onClose: n, size: 520, children: [
    /* @__PURE__ */ e(
      et,
      {
        current: o,
        items: [{ title: "Tenant details" }, { title: "Plan selection" }, { title: "Options" }],
        style: { marginBottom: 24 }
      }
    ),
    o === 0 && /* @__PURE__ */ c(v, { layout: "vertical", children: [
      /* @__PURE__ */ e(v.Item, { label: "Name", required: !0, children: /* @__PURE__ */ e(
        z,
        {
          value: l.name,
          onChange: (y) => u({ ...l, name: y.target.value })
        }
      ) }),
      /* @__PURE__ */ e(v.Item, { label: "Email", required: !0, children: /* @__PURE__ */ e(
        z,
        {
          value: l.email,
          onChange: (y) => u({ ...l, email: y.target.value })
        }
      ) })
    ] }),
    o === 1 && /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: "Plan", required: !0, children: /* @__PURE__ */ c(Ie.Group, { value: a, onChange: (y) => s(y.target.value), children: [
      /* @__PURE__ */ e(Ie, { value: "basic", children: "Basic" }),
      /* @__PURE__ */ e(Ie, { value: "pro", children: "Pro" })
    ] }) }) }),
    o === 2 && /* @__PURE__ */ e(v, { layout: "vertical", children: /* @__PURE__ */ e(v.Item, { label: "Modules", children: /* @__PURE__ */ c(Me.Group, { value: m, onChange: (y) => h(y), children: [
      /* @__PURE__ */ e(Me, { value: "sms", children: "SMS" }),
      /* @__PURE__ */ e(Me, { value: "reports", children: "Reports" })
    ] }) }) }),
    /* @__PURE__ */ c("div", { style: { marginTop: 24 }, children: [
      o > 0 && /* @__PURE__ */ e(U, { onClick: () => i(o - 1), style: { marginRight: 8 }, children: "Back" }),
      o < 2 && /* @__PURE__ */ e(U, { type: "primary", onClick: () => i(o + 1), disabled: !!N, children: "Next" }),
      o === 2 && /* @__PURE__ */ e(U, { type: "primary", onClick: C, style: { marginRight: 8 }, children: "Finish" }),
      /* @__PURE__ */ e(U, { onClick: n, children: "Cancel" })
    ] })
  ] });
}, Ft = Ot({
  appName: "MyWebApp"
}), Di = () => zt(Ft), Ii = ({
  children: t,
  appName: n
}) => {
  const [r] = L(() => new xn());
  return /* @__PURE__ */ e(Ft.Provider, { value: { appName: n }, children: /* @__PURE__ */ e(kn, { client: r, children: t }) });
}, Mi = ({
  open: t,
  sizes: n,
  onAdd: r,
  onCancel: o
}) => {
  const [i, l] = L();
  return /* @__PURE__ */ e(
    Ee,
    {
      title: "Choose Size",
      open: t,
      onOk: () => {
        i && r(i);
      },
      onCancel: o,
      okButtonProps: { disabled: !i },
      children: /* @__PURE__ */ e(Ie.Group, { onChange: (a) => l(a.target.value), value: i, children: n.map((a) => /* @__PURE__ */ e(Ie, { value: a, "aria-label": `size-${a}`, children: a }, a)) })
    }
  );
}, Ze = "id", { Dragger: wr } = Xt, xr = (t, n) => {
  const r = t.trim().split(/\r?\n/);
  if (!r.length) return [];
  const o = n ?? (r.length > 0 ? r.shift()?.split(",") ?? [] : []);
  return r.map((i, l) => {
    const u = i.split(","), a = o.reduce((s, m, h) => (s[m] = u[h] ?? "", s), {});
    return { [Ze]: l, ...a };
  });
}, Ui = ({ onUpload: t, headers: n }) => {
  const [r, o] = L([]), i = async (s) => "text" in s && typeof s.text == "function" ? s.text() : new Promise((m, h) => {
    const f = new FileReader();
    f.onload = () => m(f.result), f.onerror = () => h(f.error), f.readAsText(s);
  }), l = async (s) => {
    const m = await i(s), h = xr(m, n);
    return o(h), t(h, s), !1;
  }, a = (n ?? (r[0] ? Object.keys(r[0]).filter((s) => s !== Ze) : [])).map((s) => ({
    title: s,
    dataIndex: s,
    key: s
  }));
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ c(
      wr,
      {
        beforeUpload: l,
        showUploadList: !1,
        style: { marginBottom: 16 },
        "data-testid": "dropzone",
        children: [
          /* @__PURE__ */ e("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ e(sn, {}) }),
          /* @__PURE__ */ e("p", { className: "ant-upload-text", children: "Click or drag CSV file to this area to upload" })
        ]
      }
    ),
    r.length > 0 && /* @__PURE__ */ e(K, { dataSource: r, columns: a, pagination: !1, rowKey: Ze })
  ] });
}, kr = ({ onSubmit: t, submitting: n }) => {
  const [r] = v.useForm();
  return /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: t, children: [
    /* @__PURE__ */ e(v.Item, { label: "First name", name: "firstName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(z, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Last name", name: "lastName", rules: [{ required: !0 }], children: /* @__PURE__ */ e(z, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Email", name: "email", rules: [{ required: !0, type: "email" }], children: /* @__PURE__ */ e(z, { type: "email" }) }),
    /* @__PURE__ */ e(v.Item, { label: "Phone", name: "phone", children: /* @__PURE__ */ e(z, {}) }),
    /* @__PURE__ */ e(v.Item, { label: "Date of birth", name: "dateOfBirth", children: /* @__PURE__ */ e(xt, { style: { width: "100%" } }) }),
    /* @__PURE__ */ e(v.Item, { label: "Club ID", name: "clubId", rules: [{ required: !0 }], children: /* @__PURE__ */ e(z, { type: "number" }) }),
    /* @__PURE__ */ e(v.Item, { children: /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", loading: n, children: "Submit" }) })
  ] });
}, Ei = () => {
  const { message: t } = Se.useApp(), [n, r] = L(!1);
  return /* @__PURE__ */ e(kr, { onSubmit: async (i) => {
    r(!0);
    try {
      const l = await globalThis.fetch("/api/members/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...i, clubId: Number(i.clubId) })
      });
      if (!l.ok)
        throw new Error(l.statusText || "Signup failed");
      t.success("Signup successful");
    } catch (l) {
      const u = l;
      t.error(u.message || "Signup failed");
    } finally {
      r(!1);
    }
  }, submitting: n });
}, Fi = ({
  label: t,
  error: n,
  id: r,
  className: o = "",
  ...i
}) => {
  const l = r ?? i.name ?? t;
  return /* @__PURE__ */ c("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e("label", { htmlFor: l, className: "mb-1 text-sm font-medium", children: t }),
    /* @__PURE__ */ e(
      "input",
      {
        id: l,
        className: `border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent ${n ? "border-red-500" : "border-gray-300"} ${o}`,
        ...i
      }
    ),
    n && /* @__PURE__ */ e("p", { className: "mt-1 text-xs text-red-500", children: n })
  ] });
}, Pi = ({
  children: t,
  loading: n,
  block: r,
  className: o = "",
  disabled: i,
  ...l
}) => /* @__PURE__ */ e(
  "button",
  {
    className: `bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50 ${r ? "w-full" : ""} ${o}`,
    disabled: i || n,
    ...l,
    children: n ? "Loading..." : t
  }
);
function Bi({
  size: t = "middle",
  showTooltip: n = !0,
  className: r
}) {
  const { mode: o, toggleTheme: i } = Ct(), l = o === "dark", u = /* @__PURE__ */ e(
    U,
    {
      type: "text",
      size: t,
      icon: l ? /* @__PURE__ */ e(cn, {}) : /* @__PURE__ */ e(dn, {}),
      onClick: i,
      className: r,
      "aria-label": l ? "Switch to light mode" : "Switch to dark mode",
      style: {
        color: "inherit"
      }
    }
  );
  return n ? /* @__PURE__ */ e(vt, { title: l ? "Light mode" : "Dark mode", children: u }) : u;
}
const Cr = "_loginContainer_h81gp_10", Tr = "_heroSection_h81gp_19", _r = "_heroContent_h81gp_34", Nr = "_heroTitle_h81gp_42", Ar = "_heroSubtitle_h81gp_51", Lr = "_heroFeatures_h81gp_58", Dr = "_heroFeature_h81gp_58", Ir = "_heroFeatureIcon_h81gp_73", Mr = "_floatingShapes_h81gp_85", Ur = "_shape_h81gp_93", Er = "_shape1_h81gp_100", Fr = "_shape2_h81gp_108", Pr = "_shape3_h81gp_116", Br = "_loginContent_h81gp_140", Rr = "_background_h81gp_160", $r = "_gradientOverlay_h81gp_166", Or = "_loginCard_h81gp_171", zr = "_logoContainer_h81gp_221", Wr = "_title_h81gp_226", qr = "_subtitle_h81gp_237", Hr = "_errorAlert_h81gp_244", Vr = "_ssoButtonsContainer_h81gp_250", jr = "_ssoButtonGoogle_h81gp_280 _ssoButton_h81gp_250", Gr = "_ssoButtonFacebook_h81gp_284 _ssoButton_h81gp_250", Yr = "_dividerWrapper_h81gp_297", Kr = "_dividerLine_h81gp_306", Qr = "_formGroup_h81gp_313", Xr = "_formLabel_h81gp_317", Zr = "_formInput_h81gp_325", Jr = "_optionsRow_h81gp_338", eo = "_rememberMe_h81gp_345", to = "_forgotLink_h81gp_350", no = "_submitButton_h81gp_363", ro = "_signupText_h81gp_390", oo = "_signupLink_h81gp_399", io = "_mfaToggle_h81gp_417", ao = "_mfaCard_h81gp_421", lo = "_fullWidth_h81gp_452", _ = {
  loginContainer: Cr,
  heroSection: Tr,
  heroContent: _r,
  heroTitle: Nr,
  heroSubtitle: Ar,
  heroFeatures: Lr,
  heroFeature: Dr,
  heroFeatureIcon: Ir,
  floatingShapes: Mr,
  shape: Ur,
  shape1: Er,
  shape2: Fr,
  shape3: Pr,
  loginContent: Br,
  background: Rr,
  gradientOverlay: $r,
  loginCard: Or,
  logoContainer: zr,
  title: Wr,
  subtitle: qr,
  errorAlert: Hr,
  ssoButtonsContainer: Vr,
  ssoButtonGoogle: jr,
  ssoButtonFacebook: Gr,
  dividerWrapper: Yr,
  dividerLine: Kr,
  formGroup: Qr,
  formLabel: Xr,
  formInput: Zr,
  optionsRow: Jr,
  rememberMe: eo,
  forgotLink: to,
  submitButton: no,
  signupText: ro,
  signupLink: oo,
  mfaToggle: io,
  mfaCard: ao,
  fullWidth: lo
}, so = () => {
  try {
    const t = require("@digiwedge/ui-theme");
    if (t?.useTheme) return t.useTheme;
    if (t?.default?.useTheme) return t.default.useTheme;
  } catch {
  }
  return () => ({ mode: "light" });
}, co = so(), { Content: uo } = oe, { Title: mo, Text: Ae } = E;
function ho(t, n = "") {
  const r = typeof process < "u" ? process.env?.[t] : void 0, o = globalThis.importMetaEnv?.[t];
  return r ?? o ?? n;
}
const po = ({ style: t }) => /* @__PURE__ */ c(
  "svg",
  {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    focusable: "false",
    "aria-hidden": "true",
    style: { display: "inline-block", verticalAlign: "middle", ...t },
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#4285F4",
          d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#34A853",
          d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#FBBC05",
          d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#EA4335",
          d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        }
      )
    ]
  }
), Ri = ({
  appName: t,
  asModal: n = !1,
  backgroundClassName: r,
  backgroundImageUrl: o,
  overlay: i,
  onCloseModal: l,
  defaultEmail: u,
  defaultRemember: a,
  placeholderEmail: s,
  placeholderPassword: m,
  logoLightSrc: h,
  logoDarkSrc: f,
  signupPath: N,
  forgotPasswordPath: C,
  heroTitle: y,
  heroSubtitle: S,
  redirectTo: b = "/"
}) => {
  const D = ee(() => {
    const O = typeof t == "string" ? t.trim() : "";
    if (O && O.toLowerCase() !== "undefined" && O.toLowerCase() !== "null")
      return O;
    const $ = typeof document < "u" ? document.title : "", Q = typeof $ == "string" ? $.trim() : "";
    return Q && Q.toLowerCase() !== "undefined" && Q.toLowerCase() !== "null" ? Q : "DigiWedge";
  }, [t]), { mode: g } = co(), A = g === "dark" ? "dark" : "light", { login: W, loading: q, error: w } = Tt(), { verifyLoginMfa: F, loading: H } = _n(), [p, I] = L(() => ({
    email: u ?? "",
    password: "",
    remember: !!a
  })), [T, x] = L({}), [M, B] = L(!1), [P, te] = L(""), [X, Ne] = L(""), [J, ke] = L(!1), [Fe, se] = L(null), { message: Pe } = Se.useApp(), Be = (O) => ($) => I((Q) => ({
    ...Q,
    [O]: $.target.value
  })), Ce = (O) => I(($) => ({
    ...$,
    remember: O.target.checked
  })), ie = j.useCallback(
    (O, $, Q) => {
      Promise.resolve().then(() => {
        const me = Q ? /* @__PURE__ */ c("span", { children: [
          /* @__PURE__ */ e("span", { children: $ }),
          /* @__PURE__ */ e("div", { style: { fontSize: 12, opacity: 0.85 }, children: Q })
        ] }) : $;
        Pe.open({ type: O, content: me });
      });
    },
    [Pe]
  ), k = async (O) => {
    O.preventDefault();
    const $ = {};
    if (p.email ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email) || ($.email = d("en-US", "loginInvalidEmail")) : $.email = d("en-US", "loginEmailRequired"), p.password || ($.password = d("en-US", "loginPasswordRequired")), x($), !Object.keys($).length)
      try {
        if ((await W(p))?.mfaRequired) {
          ie("info", "Verification code sent. Check your phone."), B(!0);
          return;
        }
        ie("success", d("en-US", "loginSuccess"));
        try {
          if (typeof window < "u" && "BroadcastChannel" in window) {
            const me = new BroadcastChannel("auth");
            me.postMessage({ type: "login", at: Date.now() }), me.close();
          }
        } catch {
        }
        window.location.href = b;
      } catch (Q) {
        const me = Q?.message || "";
        /401|invalid/i.test(me) ? ie("error", "Email or password is incorrect.") : /423|lock/i.test(me) ? ie("error", "Your account is temporarily locked. Try again later or reset your password.") : /429|rate|too many/i.test(me) ? ie("error", "Too many attempts. Please wait a moment and try again.") : ie("error", d("en-US", "loginError"));
      }
  }, R = ee(
    () => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email),
    [p.email]
  ), G = ee(() => p.password.length > 0, [p.password]), ce = R && G, ue = ho("VITE_IDP_BASE_URL", "https://idp.uat.digiwedge.com").replace(/\/$/, ""), fe = encodeURIComponent(window.location.origin + "/"), Te = N ?? "/signup", ye = C ?? `${ue}/forgot-password`, Re = (O) => {
    const $ = O === "google" ? "/api/auth/google" : "/api/auth/facebook";
    window.location.href = `${ue}${$}?returnTo=${fe}`;
  }, $e = async () => {
    if (se(null), !X || !P) {
      se("Enter your User ID and the 6-digit code.");
      return;
    }
    try {
      ke(!0), await F({
        userId: X,
        code: P,
        rememberDevice: !0,
        deviceInfo: navigator.userAgent,
        // persist according to the original selection
        remember: p.remember
      }), ie("success", d("en-US", "loginSuccess")), B(!1), window.location.href = b;
    } catch (O) {
      if (In(O)) {
        const { code: $, message: Q } = Nn(O, "Verification failed");
        se($ === "otp-invalid" ? "Invalid code. Please try again." : $ === "otp-expired" ? "Code expired. Request a new code." : $ === "otp-rate-limited" ? "Too many attempts. Please wait and try again." : $ === "server-error" || $ === "network-error" ? `${Q}. You can try again.` : Q);
      } else
        se("Verification failed");
    } finally {
      ke(!1);
    }
  };
  re(() => {
    M || (Ne(""), te(""), se(null));
  }, [M]), re(() => {
    const { pathname: O } = window.location, $ = Mn(window.location);
    if (!$) return;
    const { code: Q, provider: me = "", description: Bt } = $, je = me.toLowerCase(), at = (Bt || "").trim(), lt = je ? je.charAt(0).toUpperCase() + je.slice(1) : "Social account";
    Q === "not-linked" ? ie(
      "error",
      `${lt} is not linked to your account yet. Sign in with your email to finish linking.`
    ) : Q === "oauth-failed" ? ie("error", `${lt} authentication failed.`, at || void 0) : ie("error", "Authentication failed.", at || void 0), window.history.replaceState(null, "", O);
  }, [ie]);
  const Pt = [
    "Secure single sign-on",
    "Multi-factor authentication",
    "Enterprise-grade security"
  ], it = /* @__PURE__ */ c(_e, { className: _.loginCard, bordered: !1, children: [
    /* @__PURE__ */ e("div", { className: _.logoContainer, children: /* @__PURE__ */ e(
      rt,
      {
        themeMode: A,
        size: "medium",
        lightLogoSrc: h,
        darkLogoSrc: f
      }
    ) }),
    /* @__PURE__ */ e(mo, { level: 3, className: _.title, children: "Welcome back" }),
    /* @__PURE__ */ c(Ae, { className: _.subtitle, children: [
      "Sign in to continue to ",
      D
    ] }),
    w && /* @__PURE__ */ e(
      We,
      {
        message: d("en-US", "loginFailedTitle"),
        description: /401|invalid/i.test(w.message) ? "Email or password incorrect." : /423|lock/i.test(w.message) ? "Your account is locked due to multiple failed attempts." : w?.message,
        type: "error",
        showIcon: !0,
        className: _.errorAlert
      }
    ),
    /* @__PURE__ */ c("div", { className: _.ssoButtonsContainer, children: [
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: _.ssoButtonGoogle,
          onClick: () => Re("google"),
          children: [
            /* @__PURE__ */ e(po, {}),
            /* @__PURE__ */ e("span", { children: "Continue with Google" })
          ]
        }
      ),
      /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          className: _.ssoButtonFacebook,
          onClick: () => Re("facebook"),
          children: [
            /* @__PURE__ */ e(un, { style: { fontSize: 20 } }),
            /* @__PURE__ */ e("span", { children: "Continue with Facebook" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ c("div", { className: _.dividerWrapper, children: [
      /* @__PURE__ */ e("div", { className: _.dividerLine }),
      /* @__PURE__ */ e("span", { children: "or continue with email" }),
      /* @__PURE__ */ e("div", { className: _.dividerLine })
    ] }),
    /* @__PURE__ */ c("form", { onSubmit: k, children: [
      /* @__PURE__ */ c("div", { className: _.formGroup, children: [
        /* @__PURE__ */ e("label", { className: _.formLabel, htmlFor: "email", children: "Email address" }),
        /* @__PURE__ */ e(
          z,
          {
            type: "email",
            size: "large",
            id: "email",
            className: _.formInput,
            value: p.email,
            onChange: Be("email"),
            autoComplete: "username",
            status: T.email ? "error" : "",
            placeholder: s || "you@example.com"
          }
        ),
        T.email && /* @__PURE__ */ e(Ae, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: T.email })
      ] }),
      /* @__PURE__ */ c("div", { className: _.formGroup, children: [
        /* @__PURE__ */ e("label", { className: _.formLabel, htmlFor: "password", children: "Password" }),
        /* @__PURE__ */ e(
          z.Password,
          {
            size: "large",
            id: "password",
            className: _.formInput,
            value: p.password,
            onChange: Be("password"),
            autoComplete: "current-password",
            status: T.password ? "error" : "",
            placeholder: m || "Enter your password"
          }
        ),
        T.password && /* @__PURE__ */ e(Ae, { type: "danger", style: { fontSize: 12, marginTop: 4 }, children: T.password })
      ] }),
      /* @__PURE__ */ c("div", { className: _.optionsRow, children: [
        /* @__PURE__ */ e(
          Me,
          {
            checked: p.remember,
            onChange: Ce,
            className: _.rememberMe,
            children: "Remember me"
          }
        ),
        C ? /* @__PURE__ */ e(He, { to: C, className: _.forgotLink, children: "Forgot password?" }) : /* @__PURE__ */ e("a", { href: ye, className: _.forgotLink, children: "Forgot password?" })
      ] }),
      /* @__PURE__ */ e(
        U,
        {
          htmlType: "submit",
          type: "primary",
          size: "large",
          disabled: !ce || q,
          loading: q,
          block: !0,
          className: _.submitButton,
          children: "Sign in"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: _.mfaToggle, children: /* @__PURE__ */ e(
      Zt,
      {
        activeKey: M ? ["mfa"] : [],
        onChange: (O) => {
          const $ = Array.isArray(O) ? O.includes("mfa") : !!O;
          B($);
        },
        ghost: !0,
        items: [
          {
            key: "mfa",
            label: /* @__PURE__ */ e(Ae, { type: "secondary", children: "Have a verification code?" }),
            children: /* @__PURE__ */ e("div", { className: _.mfaCard, children: /* @__PURE__ */ c(V, { direction: "vertical", className: _.fullWidth, size: "middle", children: [
              /* @__PURE__ */ e(
                z,
                {
                  placeholder: "User ID (UUID)",
                  value: X,
                  onChange: (O) => Ne(O.target.value),
                  size: "large",
                  className: _.formInput
                }
              ),
              /* @__PURE__ */ e(
                z,
                {
                  placeholder: "6-digit code",
                  inputMode: "numeric",
                  value: P,
                  onChange: (O) => te(O.target.value.replace(/\D/g, "")),
                  maxLength: 6,
                  size: "large",
                  className: _.formInput
                }
              ),
              Fe && /* @__PURE__ */ e(We, { type: "error", message: Fe, showIcon: !0 }),
              /* @__PURE__ */ e(
                U,
                {
                  type: "primary",
                  onClick: $e,
                  loading: J || H,
                  block: !0,
                  size: "large",
                  className: _.submitButton,
                  children: "Verify"
                }
              )
            ] }) })
          }
        ]
      }
    ) }),
    /* @__PURE__ */ e("div", { className: _.signupText, children: /* @__PURE__ */ c(Ae, { children: [
      d("en-US", "dontHaveAccount"),
      /* @__PURE__ */ e(He, { to: Te, className: _.signupLink, children: d("en-US", "signUpButton") })
    ] }) })
  ] });
  return n ? /* @__PURE__ */ e(
    Ee,
    {
      open: !0,
      centered: !0,
      footer: null,
      onCancel: l,
      width: 480,
      destroyOnHidden: !0,
      closable: !0,
      maskClosable: !0,
      keyboard: !0,
      styles: { body: { padding: 0 }, mask: { borderRadius: 24 } },
      children: it
    }
  ) : /* @__PURE__ */ c(oe, { className: _.loginContainer, children: [
    /* @__PURE__ */ c("div", { className: _.heroSection, children: [
      /* @__PURE__ */ c("div", { className: _.floatingShapes, children: [
        /* @__PURE__ */ e("div", { className: `${_.shape} ${_.shape1}` }),
        /* @__PURE__ */ e("div", { className: `${_.shape} ${_.shape2}` }),
        /* @__PURE__ */ e("div", { className: `${_.shape} ${_.shape3}` })
      ] }),
      /* @__PURE__ */ c("div", { className: _.heroContent, children: [
        /* @__PURE__ */ e("h1", { className: _.heroTitle, children: y || D }),
        /* @__PURE__ */ e("p", { className: _.heroSubtitle, children: S || "Your complete business management platform" }),
        /* @__PURE__ */ e("div", { className: _.heroFeatures, children: Pt.map((O, $) => /* @__PURE__ */ c("div", { className: _.heroFeature, children: [
          /* @__PURE__ */ e("span", { className: _.heroFeatureIcon, children: /* @__PURE__ */ e(mn, { style: { color: "#fff", fontSize: 14 } }) }),
          /* @__PURE__ */ e("span", { children: O })
        ] }, $)) })
      ] })
    ] }),
    /* @__PURE__ */ e(
      "div",
      {
        className: `${_.background} ${r ?? ""}`,
        style: o ? {
          backgroundImage: `url(${o})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        } : void 0
      }
    ),
    i !== "none" && /* @__PURE__ */ e("div", { className: _.gradientOverlay }),
    /* @__PURE__ */ e(uo, { className: _.loginContent, children: it })
  ] });
}, go = "_page_18e0n_1", fo = "_shell_18e0n_9", yo = "_brandPanel_18e0n_20", bo = "_brandContent_18e0n_29", So = "_brandBadge_18e0n_34", vo = "_brandTitle_18e0n_46", wo = "_brandSubtitle_18e0n_51", xo = "_brandList_18e0n_55", ko = "_brandQuote_18e0n_63", Co = "_brandQuoteText_18e0n_71", To = "_brandQuoteAuthor_18e0n_76", _o = "_formPanel_18e0n_82", No = "_formHeader_18e0n_89", Ao = "_alert_18e0n_94", Lo = "_footerRow_18e0n_98", Do = "_link_18e0n_102", Z = {
  page: go,
  shell: fo,
  brandPanel: yo,
  brandContent: bo,
  brandBadge: So,
  brandTitle: vo,
  brandSubtitle: wo,
  brandList: xo,
  brandQuote: ko,
  brandQuoteText: Co,
  brandQuoteAuthor: To,
  formPanel: _o,
  formHeader: No,
  alert: Ao,
  footerRow: Lo,
  link: Do
}, { Title: yt, Text: Le } = E, Io = [
  "Secure access with role-based permissions.",
  "Unified records across teams and workflows.",
  "Live reporting for confident decisions."
], $i = ({
  appName: t,
  logoLightSrc: n,
  logoDarkSrc: r,
  highlights: o = Io,
  quote: i = '"Onboarding our team took minutes, not days."',
  quoteAuthor: l = "Operations Lead"
}) => {
  const { message: u } = Se.useApp(), { locale: a } = Tn(), s = nt(), { register: m, loading: h, error: f } = _t(), { token: N } = Y.useToken(), C = j.useMemo(() => {
    const b = typeof t == "string" ? t.trim() : "";
    if (b && b.toLowerCase() !== "undefined" && b.toLowerCase() !== "null")
      return b;
    const D = typeof document < "u" ? document.title : "", g = typeof D == "string" ? D.trim() : "";
    return g && g.toLowerCase() !== "undefined" && g.toLowerCase() !== "null" ? g : "DigiWedge";
  }, [t]), y = async (b) => {
    try {
      await m(b), u.success(d(a, "registrationSuccess")), s("/login");
    } catch {
      u.error(d(a, "registrationError"));
    }
  }, S = {
    "--register-bg": N.colorBgLayout || "#f0f2f5",
    "--register-surface": N.colorBgContainer || "#ffffff",
    "--register-border": N.colorBorderSecondary || "#e6e8ec",
    "--register-primary": N.colorPrimary || "#1677ff"
  };
  return /* @__PURE__ */ e("div", { className: Z.page, style: S, children: /* @__PURE__ */ c("div", { className: Z.shell, children: [
    /* @__PURE__ */ c("aside", { className: Z.brandPanel, children: [
      /* @__PURE__ */ e(
        rt,
        {
          themeMode: "dark",
          size: "medium",
          lightLogoSrc: n,
          darkLogoSrc: r,
          alt: `${C} logo`
        }
      ),
      /* @__PURE__ */ c("div", { className: Z.brandContent, children: [
        /* @__PURE__ */ e("span", { className: Z.brandBadge, children: d(a, "signUpButton") }),
        /* @__PURE__ */ c(yt, { level: 2, className: Z.brandTitle, children: [
          "Create your ",
          C,
          " account"
        ] }),
        /* @__PURE__ */ e(Le, { className: Z.brandSubtitle, children: "Bring your team together with secure access and unified workflows." })
      ] }),
      /* @__PURE__ */ e("ul", { className: Z.brandList, children: o.map((b) => /* @__PURE__ */ e("li", { children: b }, b)) }),
      /* @__PURE__ */ c("div", { className: Z.brandQuote, children: [
        /* @__PURE__ */ e(Le, { className: Z.brandQuoteText, children: i }),
        /* @__PURE__ */ e(Le, { className: Z.brandQuoteAuthor, children: l })
      ] })
    ] }),
    /* @__PURE__ */ c("section", { className: Z.formPanel, children: [
      /* @__PURE__ */ c("div", { className: Z.formHeader, children: [
        /* @__PURE__ */ e(yt, { level: 3, children: d(a, "registerHeading").replace("{appName}", C) }),
        /* @__PURE__ */ e(Le, { type: "secondary", children: "Fill in the details below to get started." })
      ] }),
      f && /* @__PURE__ */ e(
        We,
        {
          message: d(a, "registrationFailedTitle"),
          description: f.message,
          type: "error",
          showIcon: !0,
          className: Z.alert
        }
      ),
      /* @__PURE__ */ c(v, { name: "register", layout: "vertical", onFinish: y, children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: d(a, "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: d(a, "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(z, { placeholder: d(a, "emailPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: d(a, "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: d(a, "registerAccountPasswordMin")
              }
            ],
            children: /* @__PURE__ */ e(z.Password, { placeholder: d(a, "passwordPlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d(a, "fullNameLabel"),
            name: "name",
            rules: [
              {
                required: !0,
                message: d(a, "fullNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(z, { placeholder: d(a, "fullNamePlaceholder"), size: "large" })
          }
        ),
        /* @__PURE__ */ e(v.Item, { label: d(a, "tenantIdLabel"), name: "tenantId", children: /* @__PURE__ */ e(z, { placeholder: d(a, "tenantIdPlaceholder"), size: "large" }) }),
        /* @__PURE__ */ e(v.Item, { label: d(a, "roleIdLabel"), name: "roleId", children: /* @__PURE__ */ e(z, { placeholder: d(a, "roleIdPlaceholder"), size: "large" }) }),
        /* @__PURE__ */ e(
          v.Item,
          {
            name: "termsAccepted",
            valuePropName: "checked",
            rules: [
              {
                validator: (b, D) => D ? Promise.resolve() : Promise.reject(new Error(d(a, "termsRequired")))
              }
            ],
            children: /* @__PURE__ */ e(Me, { children: d(a, "termsAcceptLabel") })
          }
        ),
        /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, size: "large", loading: h, children: d(a, "signUpButton") })
      ] }),
      /* @__PURE__ */ e("div", { className: Z.footerRow, children: /* @__PURE__ */ c(Le, { children: [
        d(a, "alreadyHaveAccount"),
        " ",
        /* @__PURE__ */ e(He, { to: "/login", className: Z.link, children: d(a, "loginLinkText") })
      ] }) })
    ] })
  ] }) });
}, Oi = () => {
  const t = nt(), { logout: n } = An(), { token: r } = Y.useToken(), { message: o } = Se.useApp();
  return re(() => {
    (async () => {
      try {
        await n(), o.success(d("en-US", "logoutSuccess"));
      } catch {
        o.error(d("en-US", "logoutError"));
      } finally {
        t("/login");
      }
    })();
  }, [n, t, o]), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: r.colorBgContainer
      },
      children: /* @__PURE__ */ e(St, { tip: d("en-US", "logoutProgress"), size: "large" })
    }
  );
}, Mo = () => /* @__PURE__ */ c("div", { children: [
  /* @__PURE__ */ e("h2", { children: d("en-US", "registrationComplete") }),
  /* @__PURE__ */ e("p", { children: d("en-US", "registrationCompleteDetail") }),
  /* @__PURE__ */ e("p", { children: /* @__PURE__ */ e("a", { href: "/login", children: d("en-US", "goToLogin") }) })
] }), Uo = ({
  onNext: t,
  loading: n,
  serverError: r
}) => {
  const { message: o } = Se.useApp(), [i] = v.useForm();
  return re(() => {
    if (r?.fieldErrors) {
      const u = Object.entries(r.fieldErrors).map(
        ([a, s]) => ({
          name: [a],
          errors: [s]
        })
      );
      i.setFields(u);
    }
  }, [r, i]), /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c(
    v,
    {
      form: i,
      layout: "vertical",
      onFinish: async (u) => {
        try {
          await t(u);
        } catch {
          o.error(d("en-US", "registrationSubmitError"));
        }
      },
      onFinishFailed: (u) => {
        process.env.NODE_ENV !== "test" && console.warn("Validation Failed:", u);
      },
      children: [
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "emailLabel"),
            name: "email",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountEmailRequired")
              },
              {
                type: "email",
                message: d("en-US", "registerAccountInvalidEmail")
              }
            ],
            children: /* @__PURE__ */ e(z, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "passwordLabel"),
            name: "password",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountPasswordRequired")
              },
              {
                min: 8,
                message: d("en-US", "registerAccountPasswordMin")
              },
              {
                validator: (u, a) => {
                  if (!a) return Promise.resolve();
                  const s = /[A-Z]/.test(a), m = /[a-z]/.test(a), h = /\d/.test(a);
                  return !s || !m || !h ? Promise.reject(d("en-US", "registerAccountPasswordComplex")) : Promise.resolve();
                }
              }
            ],
            children: /* @__PURE__ */ e(z.Password, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "firstNameLabel"),
            name: "givenName",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountFirstNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(z, {})
          }
        ),
        /* @__PURE__ */ e(
          v.Item,
          {
            label: d("en-US", "lastNameLabel"),
            name: "familyName",
            rules: [
              {
                required: !0,
                message: d("en-US", "registerAccountLastNameRequired")
              }
            ],
            children: /* @__PURE__ */ e(z, {})
          }
        ),
        /* @__PURE__ */ e(v.Item, { label: d("en-US", "preferredNameLabel"), name: "preferredName", children: /* @__PURE__ */ e(z, {}) }),
        /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "registerButton") })
      ]
    }
  ) });
}, Eo = ({ onLogin: t, loading: n }) => {
  const [r] = v.useForm();
  async function o(i) {
    await t(i);
  }
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "loginHeading") }),
    /* @__PURE__ */ c(
      v,
      {
        form: r,
        layout: "vertical",
        onFinish: o,
        initialValues: { email: "", password: "" },
        children: [
          /* @__PURE__ */ e(
            v.Item,
            {
              label: d("en-US", "emailLabel"),
              name: "email",
              rules: [
                {
                  required: !0,
                  message: d("en-US", "loginEmailRequired")
                },
                {
                  type: "email",
                  message: d("en-US", "loginInvalidEmail")
                }
              ],
              children: /* @__PURE__ */ e(z, {})
            }
          ),
          /* @__PURE__ */ e(
            v.Item,
            {
              label: d("en-US", "passwordLabel"),
              name: "password",
              rules: [
                {
                  required: !0,
                  message: d("en-US", "loginPasswordRequired")
                }
              ],
              children: /* @__PURE__ */ e(z.Password, {})
            }
          ),
          /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "loginButton") })
        ]
      }
    )
  ] });
}, Fo = ({ onNext: t, loading: n }) => {
  const [r] = v.useForm(), o = (i) => {
    t(i);
  };
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "mfaPhoneHeading") }),
    /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        v.Item,
        {
          label: d("en-US", "phoneNumberLabel"),
          name: "phoneNumber",
          rules: [
            {
              required: !0,
              message: d("en-US", "mfaPhoneRequired")
            }
          ],
          children: /* @__PURE__ */ e(z, { placeholder: d("en-US", "phoneNumberPlaceholder") })
        }
      ),
      /* @__PURE__ */ e(v.Item, { label: d("en-US", "mfaSecretLabel"), name: "secret", rules: [], children: /* @__PURE__ */ e(z, { placeholder: d("en-US", "mfaSecretPlaceholder") }) }),
      /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "sendCodeButton") })
    ] })
  ] });
}, Po = ({ onVerify: t, loading: n }) => {
  const [r] = v.useForm(), o = (i) => {
    t(i.code);
  };
  return /* @__PURE__ */ c("div", { children: [
    /* @__PURE__ */ e("h2", { children: d("en-US", "mfaCodeHeading") }),
    /* @__PURE__ */ c(v, { form: r, layout: "vertical", onFinish: o, children: [
      /* @__PURE__ */ e(
        v.Item,
        {
          label: d("en-US", "mfaCodeLabel"),
          name: "code",
          rules: [{ required: !0, message: d("en-US", "mfaCodeRequired") }],
          children: /* @__PURE__ */ e(z, { placeholder: d("en-US", "mfaPlaceholderCode") })
        }
      ),
      /* @__PURE__ */ e(U, { type: "primary", htmlType: "submit", block: !0, loading: n, children: d("en-US", "verifyButton") })
    ] })
  ] });
};
function bt(t) {
  return typeof t == "object" && t !== null && t.isAxiosError === !0;
}
function Bo(t) {
  switch (t) {
    case "ACCOUNT":
      return 0;
    case "LOGIN":
      return 1;
    case "MFA_PHONE":
      return 2;
    case "MFA_CODE":
      return 3;
    case "DONE":
      return 4;
  }
}
const zi = () => {
  const { token: t } = Y.useToken(), { message: n } = Se.useApp(), [r, o] = L("ACCOUNT"), [i, l] = L(""), [u, a] = L(null), { register: s, loading: m } = _t(), { login: h, loading: f } = Tt(), { registerSmsMfa: N, loading: C } = Ln(), { verifySmsMfa: y, loading: S } = Dn();
  async function b(q) {
    a(null);
    try {
      const w = await s(q);
      l(w.userId), n.success(d("en-US", "accountCreatedSuccess")), o("LOGIN");
    } catch (w) {
      bt(w) && w.response?.status === 409 ? a({
        message: d("en-US", "emailAlreadyExists"),
        fieldErrors: { email: d("en-US", "emailAlreadyExists") }
      }) : a({
        message: d("en-US", "registrationError")
      }), n.error(d("en-US", "accountCreateFailed"));
    }
  }
  async function D(q) {
    try {
      await h(q), n.success(d("en-US", "loginSuccess")), o("MFA_PHONE");
    } catch {
      n.error(d("en-US", "loginCheckError"));
    }
  }
  async function g(q) {
    try {
      await N(q), n.success(d("en-US", "mfaInitiatedSuccess")), o("MFA_CODE");
    } catch (w) {
      bt(w) && w.response?.status === 400 ? a({
        message: d("en-US", "invalidPhoneNumber"),
        fieldErrors: {
          phoneNumber: d("en-US", "invalidPhoneNumberField")
        }
      }) : a({
        message: d("en-US", "registerPhoneNumberError")
      }), n.error(d("en-US", "mfaPhoneError"));
    }
  }
  async function A(q) {
    try {
      await y({ userId: i, code: q }), n.success(d("en-US", "mfaVerifiedSuccess")), o("DONE");
    } catch {
      n.error(d("en-US", "mfaCodeError"));
    }
  }
  let W;
  return r === "ACCOUNT" ? W = /* @__PURE__ */ e(
    Uo,
    {
      onNext: b,
      loading: m,
      serverError: u
    }
  ) : r === "LOGIN" ? W = /* @__PURE__ */ e(Eo, { onLogin: D, loading: f }) : r === "MFA_PHONE" ? W = /* @__PURE__ */ e(Fo, { onNext: g, loading: C }) : r === "MFA_CODE" ? W = /* @__PURE__ */ e(Po, { onVerify: A, loading: S }) : W = /* @__PURE__ */ e(Mo, {}), /* @__PURE__ */ e(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: t.colorBgBase,
        padding: t.paddingLG
      },
      children: /* @__PURE__ */ c(
        _e,
        {
          style: {
            maxWidth: 600,
            width: "100%",
            padding: t.paddingMD,
            backgroundColor: t.colorBgContainer,
            boxShadow: t.boxShadow
          },
          children: [
            /* @__PURE__ */ e(
              et,
              {
                current: Bo(r),
                style: { marginBottom: t.marginLG },
                items: [
                  { title: d("en-US", "registrationStepAccount") },
                  { title: d("en-US", "registrationStepLogin") },
                  { title: d("en-US", "registrationStepPhone") },
                  { title: d("en-US", "registrationStepCode") },
                  { title: d("en-US", "registrationStepDone") }
                ]
              }
            ),
            W
          ]
        }
      )
    }
  );
}, { Content: Ro } = oe, { Title: $o, Text: Oo } = E, Wi = ({ user: t }) => {
  const n = typeof t.avatar == "string" ? t.avatar : void 0;
  return /* @__PURE__ */ e(oe, { style: { backgroundColor: "#f9f9f9" }, children: /* @__PURE__ */ c(Ro, { style: { padding: "40px 24px" }, children: [
    /* @__PURE__ */ e(Ye, { justify: "center", style: { textAlign: "center", marginBottom: 40 }, children: /* @__PURE__ */ c(qe, { children: [
      /* @__PURE__ */ e(
        wt,
        {
          size: 96,
          src: n,
          style: { backgroundColor: "#1890ff", marginBottom: 16 },
          children: t.displayName.charAt(0)
        }
      ),
      /* @__PURE__ */ e($o, { level: 3, children: t.displayName }),
      /* @__PURE__ */ e(Oo, { type: "secondary", children: t.email })
    ] }) }),
    /* @__PURE__ */ e(Ye, { justify: "center", children: /* @__PURE__ */ e(qe, { xs: 24, sm: 20, md: 16, lg: 12, children: /* @__PURE__ */ c(
      le,
      {
        bordered: !0,
        column: 1,
        layout: "vertical",
        style: { backgroundColor: "#fff", padding: 24, borderRadius: 12 },
        children: [
          /* @__PURE__ */ e(le.Item, { label: "Full Name", children: t.fullName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Preferred Name", children: t.preferredName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Given Name", children: t.givenName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Family Name", children: t.familyName || "N/A" }),
          /* @__PURE__ */ e(le.Item, { label: "Status", children: t.active ? /* @__PURE__ */ e(pe, { color: "green", children: "Active" }) : /* @__PURE__ */ e(pe, { color: "red", children: "Inactive" }) }),
          /* @__PURE__ */ e(le.Item, { label: "Feature Flags", children: t.featureFlags?.length ? t.featureFlags.map((r) => /* @__PURE__ */ e(pe, { color: "blue", children: r }, r)) : "None" })
        ]
      }
    ) }) })
  ] }) });
}, qi = () => {
  const { toggleTheme: t } = Ct();
  return t;
}, Hi = () => !Je.useBreakpoint().md, Vi = () => new Promise((t, n) => {
  if (!navigator.geolocation) {
    n(new Error("Geolocation is not supported by this browser."));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (r) => {
      const { latitude: o, longitude: i } = r.coords;
      t({ latitude: o, longitude: i });
    },
    (r) => {
      n(new Error(`Failed to get location: ${r.message}`));
    },
    {
      enableHighAccuracy: !0,
      timeout: 1e4,
      maximumAge: 0
    }
  );
});
function ji() {
  const { message: t } = Se.useApp();
  return {
    success(n) {
      t.success(n);
    },
    error(n) {
      t.error(n);
    }
  };
}
export {
  di as ActionFooter,
  ci as AdminFooter,
  hi as AnalyticsFooter,
  Ki as AppThemeProvider,
  Ci as BalanceWidget,
  oi as BreadcrumbComponent,
  Pi as Button,
  ii as CardUI,
  xi as ClassificationTree,
  ai as ContentWrapper,
  Ui as CsvDropzone,
  ki as CurrencyInput,
  tr as CustomBarShape,
  Dt as DateRangePicker,
  Mo as DoneScreen,
  It as Drawer,
  xe as FOOTER_MIN_HEIGHT,
  Ni as FeatureUsageDashboard,
  si as FooterComponent,
  gi as HeaderComponent,
  _i as InvoicePreviewModal,
  Ti as InvoiceTable,
  pi as LegalBar,
  Ri as Login,
  rt as LogoComponent,
  Oi as Logout,
  Pn as MarketingFooter,
  Ei as MemberSignupWidget,
  de as MoneyField,
  Si as PriceScheduleCreateWizard,
  vi as PriceScheduleEditModal,
  bi as PriceScheduleTimeline,
  Mi as ProductVariantModal,
  ar as RANGE_ERROR_END_AFTER_START,
  lr as RANGE_ERROR_OVERLAP,
  $i as Register,
  zi as RegistrationWizard,
  Nt as SAFE_AREA_INSET_BOTTOM,
  fi as SidebarComponent,
  kr as SignupForm,
  Ve as StatusChip,
  Uo as StepAccountForm,
  Po as StepMfaCodeForm,
  Fo as StepMfaPhoneForm,
  Ai as SystemHealthWidget,
  ui as TableFooterBar,
  yi as TagChip,
  mi as TenantFooter,
  Li as TenantOnboardingWizard,
  Fi as TextInput,
  Bi as ThemeToggle,
  Wi as UserProfilePage,
  Ii as WebBrandingProvider,
  ze as cloneDataNodes,
  Et as filterTree,
  Qe as findNode,
  we as findParent,
  wi as flatten,
  ot as formatCurrency,
  ve as fromDataNode,
  Vi as getBrowserLocation,
  li as getSafeAreaPaddingBottom,
  gt as indentNode,
  Oe as maxDepth,
  pt as moveNodeDown,
  ht as moveNodeUp,
  ft as outdentNode,
  Xe as removeNode,
  Ke as toDataNode,
  Mt as updateTitle,
  vr as useCreateTenantMutation,
  Hi as useIsMobile,
  ji as useNotifications,
  qi as useThemeToggle,
  Di as useWebBranding
};
//# sourceMappingURL=index.js.map
